/*! PARTPOINT search core v1.2.0 · 2026-10-08 (1.1.0 · 2026-10-02 + chips: every refine / remove / suggestion count is the count of the search it leads to; query words that read back as written)
 * Generated by tools/build-core.mjs from core.src.js + the pp-ai-chat v3.5.2 taxonomy (parts.ts, MODEL_TABLE,
 * FOREIGN). Edit the source and rebuild — do not edit this file by hand.
 *
 * One deterministic engine for every public search entry point (header, mobile menu, hero, 404, /search and the
 * suggestion popup): the same query gives the same products everywhere. Hard constraints come from the query
 * (model, model year inside the product's own range, part, side, position, level, quality, LED, SKU, free words);
 * a product whose data contradicts one is never shown as compatible, one whose data is silent is shown apart as
 * „to be confirmed“. The index is the complete published catalog (pp-search-index section) or nothing.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module && module.exports) module.exports = api;
  else root.PPSearchCore = api;
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var VERSION = '1.2.0';
  // Lookbehind and \p{…} are compiled at run time only: an engine without them (iOS < 16.4) gets
  // supported:false and the store keeps Shopify's own search — a syntax error would break the page.
  var SUPPORTED = (function () {
    try {
      new RegExp('(?<![\\p{L}])x(?=\\p{L})', 'u');
      return typeof ''.normalize === 'function' && typeof Map === 'function' && typeof Set === 'function';
    } catch (e) { return false; }
  }());
  if (!SUPPORTED) return { version: VERSION, supported: false };

  /* ------------------------------------------------------------------ data */
  var PARTS_DATA = [
    {"canon":"სანისლე ფარი","cls":"A","src":"(?<![ა-ჰ])(?:სანისლ(?!ე\\s+ფარებით)(?:ე\\s+ფარ)?|ნისლის(?:\\s+ფარ)?|ტუმან(?:კ|იკ))|(?<![а-яё])(?:противотуман|туманк)|\\bfog\\s?(?:light|lamp)s?\\b|(?<![a-z])tuman(?:k[ai]|ik[ia]|iki|ebi)(?![a-z])|(?<![а-яё])птф(?![а-яё])|туманк","accessory":false,"position":"front","sided":true,"label":{"ka":"სანისლე ფარი","ru":"противотуманная фара","en":"fog light"}},
    {"canon":"უკანა ფარი","cls":"A","src":"(?<![ა-ჰ])(?:სტოპ|მაშუქ)|უკანა\\s+(?:ფარ|სანათ)|(?<![а-яё])(?:стоп|фонар|задн\\S*\\s+фар|подфарник)|\\b(?:tail|rear|stop)\\s?(?:light|lamp)s?\\b|(?<![a-z])stop(?:i|ebi)(?![a-z])","accessory":false,"position":"rear","sided":true,"label":{"ka":"უკანა ფარი","ru":"задний фонарь","en":"tail light"}},
    {"canon":"ნომრის სანათი","cls":"A","src":"ნომრის\\s+სანათ|(?<![а-яё])подсветк\\S*\\s+номер|\\b(?:license|number)\\s+plate\\s+(?:light|lamp)s?\\b","accessory":false,"position":"rear","sided":false,"label":{"ka":"ნომრის სანათი","ru":"подсветка номера","en":"license plate light"}},
    {"canon":"დღის სინათლე","cls":"A","src":"(?<![ა-ჰ])ლედ(?:ი|ის|ები)?(?![ა-ჰ])|დღის\\s+სინათლ|(?<![а-яё])(?:дневн\\S*\\s+ход|ходов\\S*\\s+огн|дхо)|\\bDRL\\b|\\bday(?:time)?\\s+running\\s+(?:light|lamp)s?\\b","accessory":false,"position":"front","sided":true,"label":{"ka":"დღის სინათლე (LED)","ru":"дневные ходовые огни","en":"daytime running light"}},
    {"canon":"მოხვევის მაჩვენებელი","cls":"A","src":"მოხვევის\\s+მაჩვენებ|(?<![ა-ჰ])ციმციმ|(?<![а-яё])(?:поворотник|указател\\S*\\s+поворот)|\\bturn\\s+signals?\\b|\\bindicators?\\b|\\bblinkers?\\b","accessory":false,"position":null,"sided":true,"label":{"ka":"მოხვევის მაჩვენებელი","ru":"указатель поворота","en":"turn signal"}},
    {"canon":"ანჯამი","cls":"A","src":"(?<![ა-ჰ])(?:ანჯამ|პეტლ)|(?<![а-яё])петл|\\bhinges?\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"ანჯამი","ru":"петля","en":"hinge"}},
    {"canon":"საკეტი","cls":"A","src":"(?<![ა-ჰ])(?:საკეტ|ჩამკეტ)|(?<![а-яё])зам[ок]к?|\\blatch(?:es)?\\b|\\block\\b","accessory":true,"position":null,"sided":false,"label":{"ka":"საკეტი","ru":"замок","en":"latch"}},
    {"canon":"სახელური","cls":"A","src":"(?<![ა-ჰ])სახელურ|(?<![а-яё])ручк|\\bhandles?\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"სახელური","ru":"ручка","en":"handle"}},
    {"canon":"მოლდინგი","cls":"A","src":"(?<![ა-ჰ])(?:მოლდინგ|მოდლი?ნგ)|(?<![а-яё])молдинг|\\bmou?ldings?\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"მოლდინგი","ru":"молдинг","en":"molding"}},
    {"canon":"ბრეკეტი","cls":"A","src":"(?<![ა-ჰ])(?:ბრეკეტ(?!ით)|ბერეკეტ|კრონშტეინ|დამჭერ(?!ით)|სამაგრ(?!ით)|სალასკ)|(?<![а-яё])кронштейн|\\bbrackets?\\b|\\bmounts?\\b|\\bmounting\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"ბრეკეტი","ru":"кронштейн","en":"bracket"}},
    {"canon":"დამცავი","cls":"A","src":"(?<![ა-ჰ])(?:დამცავ|პადკრილნიკ|ლოკერ|ზაშიტ)|(?<![а-яё])(?:подкрыл|защит)|\\bliners?\\b|\\bundercovers?\\b|\\bsplash\\s?(?:shield|guard)s?\\b|\\bmud\\s?guards?\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"დამცავი","ru":"подкрылок / защита","en":"liner / guard"}},
    {"canon":"ძელი","cls":"A","src":"(?<![ა-ჰ])(?:ძელ|ბალკ|უსილიტელ)|(?<![а-яё])(?:усилител|балк)|\\breinforcement\\b|\\bcrossmember\\b|\\bimpact\\s?bar\\b","accessory":true,"position":null,"sided":false,"label":{"ka":"ძელი","ru":"усилитель","en":"reinforcement bar"}},
    {"canon":"ამრეკლი","cls":"A","src":"(?<![ა-ჰ])(?:ამრეკლ|კატაფოტ|რეფლექტორ|ატრაჟაწელ)|(?<![а-яё])(?:отражател|катафот)|\\breflectors?\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"ამრეკლი","ru":"отражатель","en":"reflector"}},
    {"canon":"დიფუზორი","cls":"A","src":"(?<![ა-ჰ])(?:დიფუზორ|ტუჩ|სპოილერ)|(?<![а-яё])(?:диффузор|губ[аы]|спойлер)|\\bdiffusers?\\b|\\blips?\\b|\\bspoilers?\\b","accessory":true,"position":null,"sided":false,"label":{"ka":"დიფუზორი","ru":"диффузор","en":"diffuser"}},
    {"canon":"გიტარა","cls":"A","src":"(?<![ა-ჰ])გიტარ|(?<![а-яё])гитар|\\bguitars?\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"გიტარა (ბამპერის გვერდითი საფარი)","ru":"гитара (боковая накладка бампера)","en":"bumper side trim"}},
    {"canon":"ბამპერის ცხაურა","cls":"A","src":"(?<=ბამპერ[\\s\\S]*?)(?:ცხაურ|გრილ|ეკრან|ბადე)(?![ა-ჰ]*\\s+გარეშე)|ქვედა\\s+(?:ცხაურ|გრილ|ეკრან|ბადე)|(?<=бампер[\\s\\S]*?)реш[её]тк|реш[её]тк\\S*\\s+(?:\\S+\\s+)?бампер|(?<=\\bbumper\\b[\\s\\S]*?)\\bgrilles?\\b|\\blower\\s+grilles?\\b","accessory":true,"position":null,"sided":false,"label":{"ka":"ბამპერის ცხაურა","ru":"решётка бампера","en":"bumper grille"}},
    {"canon":"ჰაერის მილი","cls":"A","src":"(?<![ა-ჰ])(?:საჰაერო|ჰაერის(?!\\s+ფილტრ)|ვოზდუხოზაბორ)|(?<![а-яё])воздухо(?!\\S*\\s+фильтр)|\\bair\\s+(?:duct|intake|guide|deflector)s?\\b|\\bducts?\\b","accessory":true,"position":null,"sided":true,"label":{"ka":"ჰაერის მილი","ru":"воздуховод","en":"air duct"}},
    {"canon":"ნომრის ჩარჩო","cls":"A","src":"ნომრის\\s+(?:ჩარჩო|დამჭერ|ბუდე|სამაგრ)|(?<![ა-ჰ])სანომრე|(?<![а-яё])номерн|\\blicense\\s+plate\\b","accessory":true,"position":null,"sided":false,"label":{"ka":"ნომრის ჩარჩო","ru":"рамка номера","en":"license plate holder"}},
    {"canon":"საბუქსირე ხუფი","cls":"A","src":"(?<![ა-ჰ])(?:საბუქსირ(?:ე\\s+ხუფ)?|ბუქსირ)|(?<![а-яё])буксир|\\btow(?:ing)?\\s+hooks?\\b","accessory":true,"position":null,"sided":false,"label":{"ka":"საბუქსირე ხუფი","ru":"заглушка буксировочного крюка","en":"tow hook cover"}},
    {"canon":"საფარი","cls":"A","src":"(?<![ა-ჰ])(?:საფარ|(?<!საბარგულის\\s)ხუფ|ნაკლადკ|კანტ|ჩარჩო|პლასტმას|სამკუთხედ|ბუმერანგ)|(?<![а-яё])(?:накладк|(?<!багажника\\s)крышк(?![а-яё]*\\s+багажник)|заглушк|рамк)|\\bcovers?\\b|\\btrims?\\b|\\bcaps?\\b|\\bbezels?\\b|\\bgarnish\\b|\\bframes?\\b","accessory":true,"position":null,"sided":false,"label":{"ka":"საფარი","ru":"накладка","en":"cover / trim"}},
    {"canon":"ჟალუზი","cls":"B","src":"(?<![ა-ჰ])ჟალუზ|(?<![а-яё])жалюзи|\\b(?:active\\s+grille\\s+)?shutters?\\b|\\blouvres?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"ჟალუზი","ru":"жалюзи радиатора","en":"active grille shutter"}},
    {"canon":"კაპოტი","cls":"B","src":"(?<![ა-ჰ])კაპოტ|(?<![а-яё])капот|\\bhoods?\\b|\\bbonnets?\\b|(?<![a-z])kapot(?:i|ebi)?(?![a-z])","accessory":false,"position":"front","sided":false,"label":{"ka":"კაპოტი","ru":"капот","en":"hood"}},
    {"canon":"საბარგული","cls":"B","src":"(?<![ა-ჰ])(?:საბარგულ|ბაგაჟნიკ)|(?<![а-яё])багажник|\\btrunk\\b|\\btailgate\\b|\\bboot\\s?lid\\b|(?<![a-z])(?:sabargul(?:i|is)?|bagaj?nik(?:i|is)?|bagazhnik)(?![a-z])","accessory":false,"position":"rear","sided":false,"label":{"ka":"საბარგული","ru":"крышка багажника","en":"trunk lid"}},
    {"canon":"ბამპერი","cls":"B","src":"(?<![ა-ჰ])ბამპ+ე?რ|(?<![а-яё])бампер|\\bbumpers?\\b|(?<![a-z])bamper(?:i|is|ebi)?(?![a-z])|(?<![ა-ჰ])ბამერ","accessory":false,"position":null,"sided":false,"label":{"ka":"ბამპერი","ru":"бампер","en":"bumper"}},
    {"canon":"ფრთა","cls":"B","src":"(?<![ა-ჰ])ფრთ(?!ხ)|(?<![ა-ჰ])ფრტ[აი](?![ა-ჰ])|(?<![ა-ჰ])ფრტის|(?<![ა-ჰ])ფრტ(?:ებ|აზე)|(?<![ა-ჰ])კრილო|(?<![а-яё])крыл|\\bfenders?\\b|\\bwings?\\b|\\bquarter\\s+panels?\\b|(?<![a-z])(?:krilo|[fp]rta|[fp]rtebi)(?![a-z])","accessory":false,"position":null,"sided":true,"label":{"ka":"ფრთა","ru":"крыло","en":"fender"}},
    {"canon":"კარი","cls":"B","src":"(?<![ა-ჰ])კარ(?![გტკბდ])|(?<![ა-ჰ])დვერკ|(?<![а-яё])двер|\\bdoors?\\b|(?<![a-z])kar(?:i|ebi|is)(?![a-z])","accessory":false,"position":null,"sided":true,"label":{"ka":"კარი","ru":"дверь","en":"door"}},
    {"canon":"ცხაურა","cls":"B","src":"(?<![ა-ჰ])(?:ცხაურ|გისოს|რეშოტკ|გრილ(?!ი?ს))(?![ა-ჰ]*\\s+გარეშე)|(?<![а-яё])реш[её]тк|\\bgrilles?\\b|\\bgrills?\\b|(?<![a-z])(?:reshotk[ai]|(?:c|ts)?xaur[ai])(?![a-z])","accessory":false,"position":"front","sided":false,"label":{"ka":"ცხაურა","ru":"решётка радиатора","en":"grille"}},
    {"canon":"ეკრანი","cls":"B","src":"(?<![ა-ჰ])ეკრან(?![ა-ჰ]*\\s+გარეშე)|(?<![ა-ჰ])ტელევიზორ|(?<![а-яё])телевизор|(?<![а-яё])передн\\S*\\s+панел|\\bfront\\s+panels?\\b|(?<![a-z])ekran(?:i|is)?(?![a-z])","accessory":false,"position":"front","sided":false,"label":{"ka":"ეკრანი","ru":"телевизор","en":"front panel"}},
    {"canon":"სარკე","cls":"B","src":"(?<![ა-ჰ])(?:სარკ|ზერკალ)|(?<![а-яё])зеркал|\\bmirrors?\\b|(?<![a-z])sark(?:e|is|eebi)(?![a-z])","accessory":false,"position":null,"sided":true,"label":{"ka":"სარკე","ru":"зеркало","en":"mirror"}},
    {"canon":"ფარი","cls":"B","src":"(?<![ა-ჰ])ფარ(?![თდ])|(?<![ა-ჰ])სანათ|(?<![а-яё])фар(?!ш)|\\bhead\\s?(?:light|lamp)s?\\b|\\blights?\\b|\\blamps?\\b|(?<![a-z])far(?:a|i|ebi|is)(?![a-z])|(?<![a-z])far(?![a-z])","accessory":false,"position":null,"sided":true,"label":{"ka":"ფარი","ru":"фара","en":"headlight"}},
    {"canon":"ავზი","cls":"C","src":"(?<![ა-ჰ])(?:ავზ|ბაჩოკ|ბაჩკ)|(?<![а-яё])бач[ок]к?|\\breservoirs?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"ავზი","ru":"бачок","en":"reservoir"}},
    {"canon":"ვენტილატორი","cls":"C","src":"(?<![ა-ჰ])ვენტილატორ|(?<![а-яё])вентилятор|\\b(?:cooling\\s+)?fans?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"ვენტილატორი","ru":"вентилятор","en":"fan"}},
    {"canon":"პანელი","cls":"C","src":"(?<![ა-ჰ])პანელ|(?<![а-яё])панел|\\bradiator\\s+support\\b|\\bpanels?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"პანელი","ru":"панель","en":"panel"}},
    {"canon":"ამორტიზატორი","cls":"C","src":"(?<![ა-ჰ])ამორტიზატორ|(?<![а-яё])амортизатор|\\bshock\\s?absorbers?\\b|\\bstruts?\\b|\\bgas\\s?springs?\\b","accessory":false,"position":null,"sided":true,"label":{"ka":"ამორტიზატორი","ru":"амортизатор","en":"shock absorber"}},
    {"canon":"აირბაგი","cls":"C","src":"(?<![ა-ჰ])აირბაგ|(?<![а-яё])подушк\\S*\\s+безопасн|\\bairbags?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"აირბაგი","ru":"подушка безопасности","en":"airbag"}},
    {"canon":"ემბლემა","cls":"C","src":"(?<![ა-ჰ])(?:ემბლემ|ლოგო)|(?<![а-яё])(?:эмблем|логотип)|\\bemblems?\\b|\\blogos?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"ემბლემა","ru":"эмблема","en":"emblem"}},
    {"canon":"ფილტრი","cls":"C","src":"(?<![ა-ჰ])ფილტრ|(?<![а-яё])фильтр|\\bfilters?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"ფილტრი","ru":"фильтр","en":"filter"}},
    {"canon":"სენსორი","cls":"C","src":"(?<![ა-ჰ])(?:სენსორ|რადარ(?!ით)|დისტრონიკ(?!ი(?:ან|თ))|დატჩიკ)|(?<![а-яё])(?:датчик|радар)|\\bsensors?\\b(?!\\s+holes?)|\\bradar\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"სენსორი","ru":"датчик","en":"sensor"}},
    {"canon":"ბერკეტი","cls":"C","src":"(?<![ა-ჰ])(?:ბერკეტ|რიჩაგ)|(?<![а-яё])рычаг|\\bcontrol\\s+arms?\\b","accessory":false,"position":null,"sided":true,"label":{"ka":"ბერკეტი","ru":"рычаг","en":"control arm"}},
    {"canon":"თაღი","cls":"C","src":"(?<![ა-ჰ])(?:თაღ|არკ)|(?<![а-яё])арк[аи]|\\bwheel\\s+arch(?:es)?\\b","accessory":false,"position":null,"sided":true,"label":{"ka":"თაღი","ru":"арка","en":"wheel arch"}},
    {"canon":"ლოკოკინა","cls":"C","src":"(?<![ა-ჰ])(?:ლოკოკინ|საყვირ|კლაქსონ)|(?<![а-яё])(?:клаксон|звуков)|\\bhorns?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"ლოკოკინა","ru":"звуковой сигнал","en":"horn"}},
    {"canon":"ბალიში","cls":"C","src":"(?<![ა-ჰ])ბალიშ|(?<![а-яё])подушк\\S*\\s+двигател|\\bengine\\s+mounts?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"ძრავის ბალიში","ru":"подушка двигателя","en":"engine mount"}},
    {"canon":"კარტერი","cls":"C","src":"(?<![ა-ჰ])კარტერ|(?<![а-яё])поддон|\\boil\\s+pan\\b|\\bsump\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"კარტერი","ru":"поддон","en":"oil pan"}},
    {"canon":"სადგამი","cls":"C","src":"(?<![ა-ჰ])(?:სადგამ|აკუს)|(?<![а-яё])(?:площадк|поддон)\\S*\\s+аккумулятор|\\bbattery\\s+trays?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"აკუმულატორის სადგამი","ru":"площадка аккумулятора","en":"battery tray"}},
    {"canon":"მინა","cls":"C","src":"(?<![ა-ჰ])(?:მინა|მინის|მინები)(?!\\s+საწმენდ)|(?<![а-яё])стекл|\\bglass\\b|\\bwindshield\\b(?!\\s+washer)","accessory":false,"position":null,"sided":false,"label":{"ka":"მინა","ru":"стекло","en":"glass"}},
    {"canon":"რადიატორი","cls":"C","src":"(?<![ა-ჰ])(?:რადიატორ|ინტერქულერ|კონდენს)|(?<![а-яё])(?:радиатор|интеркулер|конденсатор)|\\bradiators?\\b(?!\\s+support)|\\bintercoolers?\\b|\\bcondensers?\\b","accessory":false,"position":null,"sided":false,"label":{"ka":"რადიატორი","ru":"радиатор","en":"radiator"}}
  ];
  var MODELS_DATA = [
    {"canon":"Tucson","catalog":"Tucson","latin":"tucson|tuson|tuscon|tusan|tuksan|tukson","ka":"ტუქსონ|ტუსონ|ტუსან|თუსან|ტუსკონ|ტუკსონ|ტიუკსონ|ტუქსან","ru":"туксон|тусон|туссан|таксон|тусан|туксан","fuzzy":true},
    {"canon":"Santa Fe","catalog":"Santa Fe","latin":"santa[\\s-]?fe","ka":"სანტა[\\s-]?ფე","ru":"санта[\\s-]?фе","fuzzy":true},
    {"canon":"Santa Cruz","catalog":"Santa Cruz","latin":"santa[\\s-]?cruz","ka":"სანტა[\\s-]?კრუზ","ru":"санта[\\s-]?круз","fuzzy":true},
    {"canon":"Sportage","catalog":"Sportage","latin":"sportage|sportej|sportaj|sportaz|sportge","ka":"სპორტეიჯ|სპორტეჯ|სპორტეჟ|სპორტაჯ|სპორტაჟ","ru":"спортейдж|спортедж|спортаж|спортаге","fuzzy":true},
    {"canon":"Sonata","catalog":"Sonata","latin":"sonata","ka":"სონატა","ru":"соната","fuzzy":true},
    {"canon":"Elantra","catalog":"Elantra","latin":"elantra|avante","ka":"ელანტრა|ავანტე","ru":"элантра|аванте","fuzzy":true},
    {"canon":"Sorento","catalog":"Sorento","latin":"sorento","ka":"სორენტო","ru":"соренто","fuzzy":true},
    {"canon":"Optima","catalog":"Optima","latin":"optima","ka":"ოპტიმა","ru":"оптима","fuzzy":true},
    {"canon":"Cerato","catalog":"Forte","latin":"cerato|forte|(?<![a-z0-9])k[\\s-]?3(?![0-9])","ka":"სერატო|ცერატო|ფორტე|(?<![ა-ჰ])კ[\\s-]?3(?![0-9])","ru":"церато|серато|форте|(?<![а-яё])к[\\s-]?3(?![0-9])","fuzzy":true},
    {"canon":"Accent","catalog":"Accent","latin":"accent|akcent|solaris","ka":"აქცენტ|სოლარის","ru":"акцент|соляр","fuzzy":true},
    {"canon":"Kona","catalog":"Kona","latin":"(?<![a-z])kona(?:s|ze)?(?![a-z])","ka":"(?<![ა-ჰ])კონნ?ა(?:ი|ის|ს|ზე|ში|თან|დან|ით|თვის|სთვის|ისთვის|ები|ებს|ების|ებზე|ებში|ებთან|ებით)?(?![ა-ჰ])","ru":"кона(?![а-яё])","fuzzy":true},
    {"canon":"Rio","catalog":"Rio","latin":"(?<![a-z])rio(?![a-z])","ka":"(?<![ა-ჰ])რიო(?:ი|ის|ს|ზე|ში|თან|დან|ით|თვის|სთვის|ისთვის|ები|ებს|ების|ებზე|ებში|ებთან|ებით)?(?![ა-ჰ])","ru":"рио(?![а-яё])","fuzzy":true},
    {"canon":"Ceed","catalog":"Ceed","latin":"(?<![a-z])ceed(?![a-z])","ka":"(?<![ა-ჰ])სიდ(?:ი|ის|ს|ზე|ში|თან|დან|ით|თვის|სთვის|ისთვის|ები|ებს|ების|ებზე|ებში|ებთან|ებით)?(?![ა-ჰ])","ru":"сид(?![а-яё])","fuzzy":true},
    {"canon":"K5","catalog":"K5","latin":"(?<![a-z0-9])ka?[\\s-]?5(?![0-9])","ka":"(?<![ა-ჰ])კა?[\\s-]?5(?![0-9])","ru":"(?<![а-яё])к[\\s-]?5(?![0-9])","fuzzy":true},
    {"canon":"K4","catalog":"K4","latin":"(?<![a-z0-9])k[\\s-]?4(?![0-9])","ka":"(?<![ა-ჰ])კა?[\\s-]?4(?![0-9])","ru":"(?<![а-яё])к[\\s-]?4(?![0-9])","fuzzy":true},
    {"canon":"K8","catalog":"K8","latin":"(?<![a-z0-9])k[\\s-]?8(?![0-9])","ka":"(?<![ა-ჰ])კა?[\\s-]?8(?![0-9])","ru":"(?<![а-яё])к[\\s-]?8(?![0-9])","fuzzy":true},
    {"canon":"Cadenza","catalog":"Cadenza","latin":"cadenza|(?<![a-z0-9])k[\\s-]?7(?![0-9])","ka":"კადენზა|(?<![ა-ჰ])კ[\\s-]?7(?![0-9])","ru":"каденз|(?<![а-яё])к[\\s-]?7(?![0-9])","fuzzy":true},
    {"canon":"K9","catalog":"K9","latin":"quoris|(?<![a-z0-9])k[\\s-]?9(?![0-9])","ka":"კვორის|(?<![ა-ჰ])კა?[\\s-]?9(?![0-9])","ru":"куорис|(?<![а-яё])к[\\s-]?9(?![0-9])","fuzzy":true},
    {"canon":"Palisade","catalog":"Palisade","latin":"palisade|palisad","ka":"პალისეიდ|პალისად","ru":"палисад|палисейд","fuzzy":true},
    {"canon":"Seltos","catalog":"Seltos","latin":"seltos|seltosi","ka":"სელტოს","ru":"сел[ьт]?тос","fuzzy":true},
    {"canon":"Creta","catalog":"Creta","latin":"(?<![a-z])creta(?![a-z])","ka":"(?<![ა-ჰ])კრეტა(?:ი|ის|ს|ზე|ში|თან|დან|ით|თვის|სთვის|ისთვის|ები|ებს|ების|ებზე|ებში|ებთან|ებით)?(?![ა-ჰ])","ru":"крета","fuzzy":true},
    {"canon":"Venue","catalog":"Venue","latin":"venue|veniu","ka":"ვენიუ","ru":"венью","fuzzy":true},
    {"canon":"Carnival","catalog":"Carnival","latin":"carnival|sedona","ka":"კარნივალ|კარნავალ|სედონა","ru":"карнивал|седона","fuzzy":true},
    {"canon":"Picanto","catalog":"Picanto","latin":"picanto","ka":"პიკანტო","ru":"пиканто","fuzzy":true},
    {"canon":"Stinger","catalog":"Stinger","latin":"stinger","ka":"სტინგერ","ru":"стингер","fuzzy":true},
    {"canon":"Soul","catalog":"Soul","latin":"(?<![a-z])souli?(?![a-z])","ka":"(?<![ა-ჰ])სოულ(?:ი|ის|ს|ზე|ში|თან|დან|ით|თვის|სთვის|ისთვის|ები|ებს|ების|ებზე|ებში|ებთან|ებით)?(?![ა-ჰ])","ru":"(?<![а-яё])соул(?![а-яё])","fuzzy":true},
    {"canon":"Niro","catalog":"Niro","latin":"(?<![a-z])niro(?:s|ze)?(?![a-z])","ka":"(?<![ა-ჰ])ნირო(?:ი|ის|ს|ზე|ში|თან|დან|ით|თვის|სთვის|ისთვის|ები|ებს|ების|ებზე|ებში|ებთან|ებით)?(?![ა-ჰ])","ru":"(?<![а-яё])ниро(?![а-яё])","fuzzy":true},
    {"canon":"EV6","catalog":"EV6","latin":"(?<![a-z0-9])ev[\\s-]?6(?![0-9])","ka":"(?<![ა-ჰ])ევ[\\s-]?6(?![0-9])","ru":"(?<![а-яё])ев[\\s-]?6(?![0-9])","fuzzy":true},
    {"canon":"EV9","catalog":"EV9","latin":"(?<![a-z0-9])ev[\\s-]?9(?![0-9])","ka":"(?<![ა-ჰ])ევ[\\s-]?9(?![0-9])","ru":"(?<![а-яё])ев[\\s-]?9(?![0-9])","fuzzy":true},
    {"canon":"Ioniq","catalog":"Ioniq","latin":"ioniq|(?<![a-z])ionic(?![a-z])","ka":"აიონიკ|აიონიქ|იონიკ|იონიქ","ru":"айоник|ионик","fuzzy":true},
    {"canon":"Telluride","catalog":"Telluride","latin":"telluride","ka":"ტელურაიდ|თელურაიდ","ru":"тел+урайд","fuzzy":true},
    {"canon":"Mohave","catalog":"Mohave","latin":"mohave|borrego","ka":"მოჰავე|მოხავე","ru":"мохав","fuzzy":true},
    {"canon":"Staria","catalog":"Staria","latin":"staria","ka":"სტარია","ru":"стария","fuzzy":true},
    {"canon":"Bayon","catalog":"Bayon","latin":"bayon","ka":"ბაიონ","ru":"байон","fuzzy":true},
    {"canon":"Genesis","catalog":"Genesis","latin":"genesis","ka":"ჯენესის|გენეზის","ru":"генезис|дженезис","fuzzy":true},
    {"canon":"Getz","catalog":"Getz","latin":"getz","ka":"გეც","ru":"гетц","fuzzy":true},
    {"canon":"Veloster","catalog":"Veloster","latin":"veloster","ka":"ველოსტერ","ru":"велостер","fuzzy":true},
    {"canon":"Sonet","catalog":"Sonet","latin":"(?<![a-z])sonet(?![a-z])","ka":"სონეტ","ru":"сонет","fuzzy":true},
    {"canon":"i10","catalog":"i10","latin":"(?<![a-z0-9])i[\\s-]?10(?![0-9])","ka":"(?<![ა-ჰ])ი[\\s-]?10(?![0-9])","ru":"(?<![а-яё])и[\\s-]?10(?![0-9])","fuzzy":true},
    {"canon":"i20","catalog":"i20","latin":"(?<![a-z0-9])i[\\s-]?20(?![0-9])","ka":"(?<![ა-ჰ])ი[\\s-]?20(?![0-9])","ru":"(?<![а-яё])и[\\s-]?20(?![0-9])","fuzzy":true},
    {"canon":"i30","catalog":"i30","latin":"(?<![a-z0-9])i[\\s-]?30(?![0-9])","ka":"(?<![ა-ჰ])ი[\\s-]?30(?![0-9])","ru":"(?<![а-яё])и[\\s-]?30(?![0-9])","fuzzy":true},
    {"canon":"i40","catalog":"i40","latin":"(?<![a-z0-9])i[\\s-]?40(?![0-9])","ka":"(?<![ა-ჰ])ი[\\s-]?40(?![0-9])","ru":"(?<![а-яё])и[\\s-]?40(?![0-9])","fuzzy":true},
    {"canon":"Grandeur","catalog":"Grandeur","latin":"grandeur|azera","ka":"გრანდეურ|გრანდერ|აზერა","ru":"грандеур|грандер|азера","fuzzy":false},
    {"canon":"Starex","catalog":"Starex","latin":"starex|staria?x","ka":"სტარექს|სტარეკს","ru":"старекс","fuzzy":false},
    {"canon":"Porter","catalog":"Porter","latin":"(?<![a-z])porter(?![a-z])","ka":"(?<![ა-ჰ])პორტერ","ru":"(?<![а-яё])портер","fuzzy":false},
    {"canon":"Bongo","catalog":"Bongo","latin":"(?<![a-z])bongo(?![a-z])","ka":"(?<![ა-ჰ])ბონგო","ru":"(?<![а-яё])бонго","fuzzy":false},
    {"canon":"Carens","catalog":"Carens","latin":"carens","ka":"კარენს","ru":"каренс","fuzzy":false},
    {"canon":"Magentis","catalog":"Magentis","latin":"magentis","ka":"მაგენტის","ru":"маджентис|магентис","fuzzy":false},
    {"canon":"Spectra","catalog":"Spectra","latin":"(?<![a-z])spectra(?![a-z])","ka":"(?<![ა-ჰ])სპექტრა","ru":"(?<![а-яё])спектр[аы]","fuzzy":false},
    {"canon":"Morning","catalog":"Morning","latin":"kia[\\s-]+morning","ka":"(?<![ა-ჰ])მორნინგ","ru":"(?<![а-яё])морнинг","fuzzy":false},
    {"canon":"Equus","catalog":"Equus","latin":"(?<![a-z])equus(?![a-z])","ka":"ეკვუს","ru":"эквус","fuzzy":false},
    {"canon":"Veracruz","catalog":"Veracruz","latin":"veracruz|(?<![a-z0-9])ix[\\s-]?55(?![0-9])","ka":"ვერაკრუზ","ru":"веракруз","fuzzy":false},
    {"canon":"Terracan","catalog":"Terracan","latin":"terracan","ka":"ტერაკან","ru":"терракан","fuzzy":false},
    {"canon":"Galloper","catalog":"Galloper","latin":"galloper","ka":"გალოპერ","ru":"галлопер","fuzzy":false},
    {"canon":"ix35","catalog":"ix35","latin":"(?<![a-z0-9])ix[\\s-]?35(?![0-9])","ka":"(?<![ა-ჰ])იქს[\\s-]?35(?![0-9])","ru":"(?<![а-яё])(?:ай|и)кс[\\s-]?35(?![0-9])","fuzzy":false}
  ];
  var FOREIGN_SRC = [
    "\\b(?:ssangyong|rexton|cherokee|tiggo|toyota|lexus|mercedes(?:-benz)?|benz|bmw|audi|volkswagen|vw|skoda|porsche|opel|ford|chevrolet|chevy|nissan|infiniti|honda|acura|mazda|mitsubishi|subaru|suzuki|renault|peugeot|citroen|citroën|fiat|volvo|tesla|jaguar|land\\s*rover|range\\s*rover|jeep|dodge|chrysler|cadillac|lincoln|buick|gmc|daewoo|ssang\\s*yong|lada|vaz|uaz|geely|chery|byd|haval|great\\s*wall|changan|zeekr|lifan|alfa\\s*romeo|maserati|bentley|rolls[-\\s]*royce|ferrari|lamborghini|dacia|cupra|isuzu|hummer|saab|mini\\s+cooper)(?:is|ze|shi|s)?\\b",
    "\\b(?:camry|corolla|prius|rav\\s*-?4|land\\s*cruiser|prado|highlander|yaris|auris|avensis|golf|passat|jetta|tiguan|touareg|civic|accord|cr-?v|outback|forester|impreza|qashqai|x-?trail|juke|altima|pajero|outlander|lancer|delica|mustang|cruze|malibu|captiva|aveo|lacetti|nexia|matiz|octavia|duster|logan|astra|vectra|zafira|insignia)(?:is|ze|shi|s)?\\b",
    "\\bmersi\\s+[a-z]\\s*-?\\s*klas",
    "\\bmersi\\s+[a-z]{1,3}\\d{2,3}\\b",
    "\\bmerc\\b",
    "jeep\\s+\\w+",
    "(?<![ა-ჰ])(?:ჩერი\\s+(?:თიგო|ტიგო|ტიგგო)|თიგო|ჯიპ\\s+(?:კომპას|ჩეროკ|რენეგად|რენგლერ|გრანდ|ლიბერთ)|მერს(?:ის|ზე|ში)(?![ა-ჰ])|მერსი?\\s+(?:[a-z]{1,3}\\d{2,3}|[a-z]\\s*-?\\s*კლას)(?![a-z])|ჩეროკ|ჟიგულ|სანგიონგ|სანიონგ|რექსტონ|კორანდო|ტოიოტ|ლექსუს|მერსედეს|ბენც|ბმვ|ბეემვე|აუდი(?!ო)|ფოლკსვაგენ|ფოლცვაგენ|ფოლქსვაგენ|შკოდა|პორშე|ოპელ|ფორდ|შევროლე|შევრალე|ნისან|ნისსან|ინფინიტ|ჰონდა|აკურა|მაზდა|მიცუბიშ|მიცუბის|მიცუბიც|სუბარუ|სუზუკ|რენო(?:ს|ზე|ის)?(?![ა-ჰ])|პეჟო|სიტროენ|ფიატ|ვოლვო|ტესლა|იაგუარ|ჯაგუარ|ლენდ\\s*როვერ|რეინჯ\\s*როვერ|რენჯ\\s*როვერ|დოჯ|კრაისლერ|კადილაკ|დეუ(?:ს|ზე|ის)?(?![ა-ჰ])|ლადა|ჯილი|ჰავალ|ისუზუ|ჰამერ|კამრი|კოროლა|პრიუს|პრადო|ლენდ\\s*კრუიზერ|ჰაილენდერ|გოლფ|პასატ|ჯეტა|ტიგუან|ტუარეგ|სივიკ|აუთბექ|ფორესტერ|იმპრეზა|კაშკა|ალტიმა|პაჯერო|აუთლენდერ|ლანსერ|დელიკა|მუსტანგ|მალიბუ|კაპტივა|ავეო|ლაჩეტ|ნექსია|მატიზ|ოქტავია|დასტერ|ვექტრა|ზაფირა)",
    "(?<![а-яё])(?:мерс(?![а-яё])|жигул|ссанг|санг\\s*[йи]онг|рекстон|чероки|тойот|лексус|мерседес|бмв|ауди(?!о)|фольксваген|шкод|порше|опел|форд|шевроле|ниссан|инфинити|хонд|акур[аы](?![а-яё])|мазд|мицубиси|митсубиси|субару|сузуки|рено(?![а-яё]{2})|пежо|ситроен|фиат|вольво|тесл|ягуар|ленд\\s*ровер|рейндж\\s*ровер|додж|крайслер|кадиллак|дэу|лад[аеу](?![а-яё])|ладой|ваз(?![а-яё])|уаз(?![а-яё])|джили|хавал|исузу|хаммер|камри|корол+а|приус|прадо|ленд\\s*крузер|хайлендер|ярис|гольф|пассат|джетт|тигуан|туарег|цивик|аутбек|форестер|импрез|кашка|аутлендер|лансер|паджеро|делик[аи](?![а-яё])|мустанг|малибу|каптив|авео|лачетти|нексия|матиз|октави|дастер|логан|астр[аы](?![а-яё])|вектр)"
  ].join('|');

  var CATALOG_YEAR_FROM = 2017;
  var CATALOG_YEAR_TO = 2026;
  var YEAR_MIN = 1990;
  var YEAR_MAX = 2035;
  var MAX_QUERY = 200;
  var MAX_TOKENS = 16;

  // 1.1.0: every pattern built while the engine starts is listed, so warmRegexes() can let the browser compile them
  // in small slices (while the index is still on the network) instead of all at once inside the first query.
  var WARM_LIST = [], WARM_OPEN = true;
  function rx(src, flags) { var re = new RegExp(src, flags || 'iu'); if (WARM_OPEN) WARM_LIST.push(re); return re; }
  function uniq(list) { var seen = new Set(), out = []; for (var i = 0; i < list.length; i++) { var v = list[i]; if (!seen.has(v)) { seen.add(v); out.push(v); } } return out; }
  function has(obj, key) { return Object.prototype.hasOwnProperty.call(obj, key); }

  /* --------------------------------------------------------- normalization */
  var CTRL = /[\u0000-\u001F\u007F-\u009F\u00AD\u200B-\u200F\u2028\u2029\u202A-\u202E\u2060-\u2064\uFEFF]/g;
  /** NFC, control/format characters out, Mtavruli → Mkhedruli, lower case, ё → е, bounded length. */
  function fold(text, limit) {
    var s = String(text == null ? '' : text);
    if (s.length > (limit || 600)) s = s.slice(0, limit || 600);
    s = s.normalize('NFC').replace(CTRL, ' ').replace(/\u00A0/g, ' ');
    s = s.replace(/[\u1C90-\u1CBF]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xBC0); });
    return s.toLowerCase().replace(/ё/g, 'е').replace(/[‐‑‒–—―]/g, '-');
  }
  var PUNCT = rx('[^\\p{L}\\p{N}\\-./+&]+', 'gu');
  /** Folded text with punctuation turned into spaces („Tucson,2023“ → „tucson 2023“). */
  function clean(text, limit) { return fold(text, limit).replace(PUNCT, ' ').replace(/\s+/g, ' ').trim(); }
  var WORDSEP = rx('[^\\p{L}\\p{N}]+', 'gu');
  function wordsOf(text) { return clean(text).split(WORDSEP).filter(Boolean); }

  /* ------------------------------------------------------------------- SKU */
  var CYR_LATIN = { 'а': 'A', 'в': 'B', 'с': 'C', 'е': 'E', 'к': 'K', 'м': 'M', 'н': 'H', 'о': 'O', 'р': 'P', 'т': 'T', 'х': 'X', 'у': 'Y' };
  /** „ka 04271-bc“, „КА04271ВС“ (Cyrillic look-alikes) → „KA04271BC“. */
  function normSku(value) {
    var s = fold(value, 80).replace(/[авсекмнортху]/g, function (c) { return CYR_LATIN[c] || c; });
    return s.toUpperCase().replace(/[^A-Z0-9]/g, '');
  }
  function skuLike(compact) { return compact.length >= 5 && compact.length <= 24 && (compact.match(/\d/g) || []).length >= 3; }
  var VIN_RE = rx('(?<![A-Z0-9])[A-HJ-NPR-Z0-9]{17}(?![A-Z0-9])', 'i');

  /* ----------------------------------------------------------------- parts */
  var KA = '(?<![ა-ჰ])';
  var PARTS = PARTS_DATA.map(function (p) {
    return {
      canon: p.canon, cls: p.cls, accessory: p.accessory, position: p.position, sided: p.sided, label: p.label,
      re: rx(p.src, 'iu'), g: rx(p.src, 'giu'), whole: rx('(?:' + p.src + ')\\p{L}*', 'giu')
    };
  });
  var PART_BY = new Map(PARTS.map(function (p) { return [p.canon, p]; }));
  var INHERENT_PARENT = { 'ბამპერის ცხაურა': ['ბამპერი', 'ცხაურა'] };
  var NOT_A_PARENT = new Set(['სენსორი', 'ემბლემა', 'ლოკოკინა', 'ბერკეტი', 'თაღი', 'მინა']);
  var PRODUCT_TYPE_PARTS = { 'ფარი': 'ფარი', 'ბამპერი': 'ბამპერი', 'ფრთა': 'ფრთა', 'კარები': 'კარი', 'ეკრანი': 'ეკრანი', 'კაპოტი': 'კაპოტი', 'საბარგული': 'საბარგული' };

  function headFirst(text) {
    var cyr = (text.match(/[а-яё]/giu) || []).length, other = (text.match(/[ა-ჰa-z]/giu) || []).length;
    return cyr > other;
  }
  function partHits(part, text) {
    var re = part.g, out = [], m;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      var end = m.index + m[0].length;
      var tail = (/^[ა-ჰ]*/u.exec(text.slice(end)) || [''])[0];
      var token = text.slice(m.index, end) + tail;
      // genitive („ბამპერის“) and instrumental („ფარებით“ = with lamps) words modify the head noun, they are not it
      var genitive = /[ა-ჰ]/u.test(token) && /(?:ის|ების|ებისა|ით|ებით)$/u.test(token);
      // „ფარების წყვილი“ / „კომპლექტი“ — a pair of the part is the part itself
      if (genitive && PAIR_AFTER.test(text.slice(m.index + token.length))) genitive = false;
      out.push({ start: m.index, end: end, tokenEnd: m.index + token.length, genitive: genitive });
      if (m[0].length === 0) re.lastIndex += 1;
    }
    return out;
  }
  var PAIR_AFTER = /^\s+(?:წყვილ|კომპ?ლექტ|ნაკრებ|ორივე)/u;
  function better(a, b, leftmost) {
    if (a.genitive !== b.genitive) return !a.genitive;
    if (leftmost) return a.start !== b.start ? a.start < b.start : a.end - a.start > b.end - b.start;
    return a.end !== b.end ? a.end > b.end : a.end - a.start > b.end - b.start;
  }
  function pickIn(cls, text, except) {
    var leftmost = headFirst(text), best = null, bestHit = null;
    for (var i = 0; i < PARTS.length; i++) {
      var part = PARTS[i];
      if (part.cls !== cls || part.canon === except || !part.re.test(text)) continue;
      var hits = partHits(part, text);
      for (var j = 0; j < hits.length; j++) if (bestHit === null || better(hits[j], bestHit, leftmost)) { best = part; bestHit = hits[j]; }
    }
    return best;
  }
  /** One pass over the taxonomy: the head part, its parent (for an accessory) and whether the head is only genitive. */
  function analyzeParts(text) {
    var t = String(text).normalize('NFC'), leftmost = headFirst(t), found = [];
    for (var i = 0; i < PARTS.length; i++) if (PARTS[i].re.test(t)) found.push({ part: PARTS[i], hits: partHits(PARTS[i], t) });
    function pick(cls, except) {
      var best = null, bestHit = null;
      for (var k = 0; k < found.length; k++) {
        var f = found[k];
        if (f.part.cls !== cls || f.part.canon === except) continue;
        for (var j = 0; j < f.hits.length; j++) if (bestHit === null || better(f.hits[j], bestHit, leftmost)) { best = f; bestHit = f.hits[j]; }
      }
      return best;
    }
    var head = pick('A') || pick('B') || pick('C');
    var out = { head: head ? head.part : null, parent: null, genitive: false, adjacent: [] };
    // two class-A nouns side by side name one piece by both („მოლდინგი ტუჩი“ — a molding lip)
    var aHits = [];
    for (var q = 0; q < found.length; q++) {
      if (found[q].part.cls !== 'A') continue;
      for (var h = 0; h < found[q].hits.length; h++) if (!found[q].hits[h].genitive) aHits.push({ canon: found[q].part.canon, start: found[q].hits[h].start, end: found[q].hits[h].tokenEnd });
    }
    if (aHits.length > 1) {
      aHits.sort(function (x, y) { return x.start - y.start; });
      for (var z = 1; z < aHits.length; z++) {
        if (aHits[z].canon !== aHits[z - 1].canon && /^\s+$/.test(t.slice(aHits[z - 1].end, aHits[z].start))) {
          [aHits[z - 1].canon, aHits[z].canon].forEach(function (c) { if (out.adjacent.indexOf(c) < 0) out.adjacent.push(c); });
        }
      }
    }
    if (!head) return out;
    out.genitive = head.hits.length > 0 && head.hits.every(function (h) { return h.genitive; });
    if (head.part.accessory) {
      for (var k = 0; k < found.length; k++) {
        var p = found[k].part;
        if (p.cls === 'A' && !p.accessory && p.canon !== head.part.canon) { out.parent = p.canon; return out; }
      }
      var main = pick('B', head.part.canon);
      if (main) out.parent = main.part.canon;
      else {
        var comp = pick('C', head.part.canon);
        out.parent = comp && !NOT_A_PARENT.has(comp.part.canon) ? comp.part.canon : null;
      }
    }
    return out;
  }
  function partTypeIn(text) { return analyzeParts(text).head; }
  function partParentIn(text) { return analyzeParts(text).parent; }
  function partHeadIsGenitive(text) { return analyzeParts(text).genitive; }
  var CONJ = /\s*(?:\+|&|,|\/|\sდა\s|\sან\s|\sи\s|\sили\s|\sand\s|\sor\s)\s*/iu;
  /** Every A/B part named in its own right in a kit title or a multi-part query („ბამპერი + გრილი“). */
  function namedParts(text, whole) {
    var t = String(text).normalize('NFC');
    var first = whole || analyzeParts(t);
    if (!CONJ.test(t)) {
      if (!first.head || first.genitive) return [];
      var out1 = [first.head.canon];
      if (first.head.cls === 'A') first.adjacent.forEach(function (c) { if (out1.indexOf(c) < 0) out1.push(c); });
      return out1;
    }
    var pieces = t.split(CONJ), out = [];
    for (var i = 0; i < pieces.length; i++) {
      var a = analyzeParts(pieces[i]);
      if (a.head && !a.genitive && out.indexOf(a.head.canon) < 0) out.push(a.head.canon);
    }
    return out;
  }
  function stripPartNames(text) {
    var t = text;
    for (var i = 0; i < PARTS.length; i++) {
      if (PARTS[i].cls === 'C') continue;
      PARTS[i].whole.lastIndex = 0;
      t = t.replace(PARTS[i].whole, ' ');
    }
    return t.replace(/\s+/g, ' ').trim();
  }
  function partLabel(canon, lang) { var p = PART_BY.get(canon); return p ? (p.label[lang] || p.label.ka) : canon || ''; }

  /* ---------------------------------------------------------------- models */
  var MODELS = MODELS_DATA.map(function (m) {
    return {
      canon: m.canon, catalog: m.catalog, fuzzy: m.fuzzy,
      re: rx([m.latin, m.ka, m.ru].filter(Boolean).join('|'), 'iu'),
      strip: rx('(?:' + [m.latin, m.ka, m.ru].filter(Boolean).join('|') + ')(?:-?[\\u10A0-\\u10FF\\u1C90-\\u1CBF\\u0400-\\u04FF]+)?', 'giu'),
      words: uniq([m.catalog.toLowerCase()].concat(aliasWords(m.ka), aliasWords(m.ru)))
        .filter(function (w) { return w.length >= 4 && /^[\p{L}\p{N}]+$/u.test(w); })
    };
  });
  /**
   * The plain spellings inside an alias pattern, for typo matching: look-arounds, optional groups/letters and
   * character classes out, then split. („(?<![ა-ჰ])კონნ?ა(?:ი|ის|…)?(?![ა-ჰ])“ → „კონა“ — before this, the case
   * endings inside the group were split out as if they were model names.)
   */
  function aliasWords(src) {
    return String(src || '')
      .replace(/\(\?<?[!=][^()]*\)/g, '')
      .replace(/\(\?:[^()]*\)\??/g, '')
      .replace(/\[[^\]]*\][?*+]?/g, '')
      .replace(/\\[a-z][?*+]?/gi, '')
      .replace(/[^|]\?/gu, '')
      .replace(/\+/g, '')
      .split('|')
      .map(function (w) { return w.trim().toLowerCase(); });
  }
  var MODEL_BY = new Map(MODELS.map(function (m) { return [m.canon, m]; }));
  var KIA_MODELS = new Set(['Sportage', 'Sorento', 'Optima', 'Cerato', 'Rio', 'Ceed', 'K5', 'K4', 'K8', 'Cadenza', 'K9', 'Seltos', 'Carnival', 'Picanto', 'Stinger', 'Soul', 'Niro', 'EV6', 'EV9', 'Telluride', 'Mohave', 'Sonet', 'Bongo', 'Carens', 'Magentis', 'Spectra', 'Morning']);
  var BRAND_HYUNDAI = rx('\\bhyundai\\b|ჰიუნდა[იე]|ჰუნდა[იე]|ჰიონდა[იე]|х[её]нда[йи]|хюнда[йи]|хунда[йи]|х[её]ндэ', 'iu');
  var BRAND_KIA = rx('\\bkia\\b|(?<![ა-ჰ])კია(?![ა-ჰ])|(?<![а-я])ки[ая](?![а-я])', 'iu');
  var FOREIGN = FOREIGN_SRC ? rx(FOREIGN_SRC, 'iu') : null;

  function brandIn(text) { return BRAND_HYUNDAI.test(text) ? 'Hyundai' : BRAND_KIA.test(text) ? 'KIA' : null; }
  function brandOf(model) { return KIA_MODELS.has(model) ? 'KIA' : 'Hyundai'; }
  function modelName(canon) { var m = MODEL_BY.get(canon); return m ? m.catalog : canon; }
  function directModels(text) {
    var out = [];
    for (var i = 0; i < MODELS.length; i++) if (MODELS[i].re.test(text)) out.push(MODELS[i].canon);
    return out;
  }
  function stripModelNames(text) {
    var t = text;
    for (var i = 0; i < MODELS.length; i++) { MODELS[i].strip.lastIndex = 0; t = t.replace(MODELS[i].strip, ' '); }
    return t.replace(BRAND_HYUNDAI, ' ').replace(BRAND_KIA, ' ').replace(/\s+/g, ' ').trim();
  }
  /** Bounded Damerau-Levenshtein (a swapped pair costs 1). */
  function editDistance(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = [], prev = [], i, j;
    for (j = 0; j <= b.length; j++) prev.push(j);
    for (i = 1; i <= a.length; i++) {
      var row = [i], best = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(row[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        row.push(v);
        if (v < best) best = v;
      }
      if (best > max) return max + 1;
      prev2 = prev; prev = row;
    }
    return prev[b.length];
  }
  var FUZZY_STOP = new Set(['need', 'needs', 'seed', 'feed', 'deed', 'weed', 'force', 'forth', 'morning', 'working', 'bacon', 'bingo', 'accept', 'sorter', 'nitro', 'nero', 'soup', 'sour', 'solo', 'sold', 'seat', 'sorry', 'sport', 'sports', 'limited', 'light', 'lights', 'front', 'right']);
  var FUZZY_STOP_RE = /^(?:მოხვევ|работ|სპორტ)/u;
  /** One typo away from exactly one carried model („სანატა“ → Sonata, „туссон“ → Tucson), else null. */
  function fuzzyModel(text, carried) {
    var words = fold(text).split(WORDSEP).filter(function (w) { return w.length >= 4 && w.length <= 14; });
    for (var i = 0; i < words.length; i++) {
      var raw = words[i];
      if (FUZZY_STOP.has(raw) || FUZZY_STOP_RE.test(raw) || /\d/.test(raw) || partTypeIn(raw)) continue;
      var stem = raw.replace(/(?:ის|ი|ს)$/u, '');
      var forms = stem.length >= 4 && stem !== raw ? [raw, stem] : [raw];
      // Georgian genitive of a name in -ა drops the ა: „კონის“ ← კონა, „კრეტის“ ← კრეტა (the same name, not a typo)
      var genitive = /ის$/u.test(raw) && raw.length >= 5 ? raw.slice(0, -2) + 'ა' : null;
      var hits = new Set(), exact = false;
      for (var k = 0; k < MODELS.length && hits.size < 2; k++) {
        var m = MODELS[k];
        if (!m.fuzzy || (carried && carried.size && !carried.has(m.canon))) continue;
        for (var w = 0; w < m.words.length; w++) {
          var word = m.words[w];
          if (genitive && genitive === word) { hits.add(m.canon); exact = true; break; }
          // two edits only between two long words: „სონატ“ (stem) is not two edits from „კონა“
          if (forms.some(function (f) { var budget = Math.min(f.length, word.length) >= 7 ? 2 : 1; return editDistance(f, word, budget) <= budget; }) || (raw.length > word.length && raw.indexOf(word) === 0)) { hits.add(m.canon); break; }
        }
      }
      if (hits.size === 1) return { model: hits.values().next().value, word: raw, exact: exact };
    }
    return null;
  }

  /* ----------------------------------------------------------------- years */
  var TITLE_RANGE = rx('(?<!\\d)((?:19|20)\\d{2})\\s*[-–—]\\s*((?:19|20)\\d{2}|\\d{2})(?![\\d])', 'g');
  /** Model-year ranges written in a title or tag („2022-2024“, „2022-23“). A lone year is not a range. */
  function rangesIn(text) {
    var out = [], seen = new Set(), m;
    TITLE_RANGE.lastIndex = 0;
    while ((m = TITLE_RANGE.exec(text)) !== null) {
      var a = Number(m[1]), b = m[2].length === 2 ? Math.floor(a / 100) * 100 + Number(m[2]) : Number(m[2]);
      if (m[2].length === 2 && b < a) continue;
      var from = Math.min(a, b), to = Math.max(a, b);
      if (from < YEAR_MIN || to > YEAR_MAX || to - from > 20) continue;
      var key = from + '-' + to;
      if (!seen.has(key)) { seen.add(key); out.push({ from: from, to: to }); }
    }
    return out;
  }
  var Q_RANGE = rx('(?<![\\dA-Za-z])((?:19|20)\\d{2})\\s*[-–—]\\s*((?:19|20)\\d{2}|\\d{2})(?![\\dA-Za-z])', 'g');
  var Q_YEAR = rx('(?<![\\dA-Za-z.,])((?:19|20)\\d{2})(?![\\dA-Za-z]|[.,]\\d)', 'g');
  var Q_SHORT = rx('(?<![\\d.,])(\\d{2})\\s*-?\\s*(?:წ(?:ლ|ელ)[ა-ჰ]*|იან[ა-ჰ]*|god[a-z]*|год[а-я]*|г\\.)(?![\\p{L}])', 'giu');
  var PRICE_AFTER = /^\s*(?:₾|ლარ|gel\b|лар|\$|usd\b|დოლარ|-?მდე|евро|€)/iu;
  var PRICE_BEFORE = /(?:ფას[იშა]?|ღირს|ღირებულებ[აი]|price|цен[аеы]|стоит)\s*[-—:]?\s*$/iu;
  var WHEEL = /^\s*-?\s*(?:იან[ა-ჰ]*\s*)?(?:დისკ|საბურავ|რეზინ|ინჩ|disk|шин|диск|inch)/iu;
  /** Model years the customer states: 2023, 2019-2022 (expanded), „22 წლის“, „18-იანი“; prices are not years. */
  function queryYears(text) {
    var years = [], typedRange = null, m;
    function push(y) { if (y >= YEAR_MIN && y <= YEAR_MAX && years.indexOf(y) < 0) years.push(y); }
    Q_RANGE.lastIndex = 0;
    var spans = [];
    while ((m = Q_RANGE.exec(text)) !== null) {
      var a = Number(m[1]), b = m[2].length === 2 ? Math.floor(a / 100) * 100 + Number(m[2]) : Number(m[2]);
      if (b < a || b - a > 20) continue;
      typedRange = { from: a, to: b };
      for (var y = a; y <= b; y++) push(y);
      spans.push([m.index, m.index + m[0].length]);
    }
    Q_YEAR.lastIndex = 0;
    while ((m = Q_YEAR.exec(text)) !== null) {
      var at = m.index;
      if (spans.some(function (s) { return at >= s[0] && at < s[1]; })) continue;
      if (PRICE_AFTER.test(text.slice(at + 4)) || PRICE_BEFORE.test(text.slice(0, at))) continue;
      push(Number(m[1]));
    }
    Q_SHORT.lastIndex = 0;
    while ((m = Q_SHORT.exec(text)) !== null) {
      if (WHEEL.test(text.slice(m.index + 2))) continue;
      var n = Number(m[1]);
      push(n <= 40 ? 2000 + n : 1900 + n);
    }
    years.sort(function (x, z) { return x - z; });
    return { years: years, range: typedRange };
  }
  /** Do the stated years fit a range? One year → inside; several → at least two of them inside (a real overlap). */
  function yearsFit(ranges, years) {
    if (!years.length) return true;
    if (!ranges.length) return false;
    if (years.length === 1) return ranges.some(function (r) { return years[0] >= r.from && years[0] <= r.to; });
    var need = Math.min(2, years.length);
    return ranges.some(function (r) { return years.filter(function (y) { return y >= r.from && y <= r.to; }).length >= need; });
  }

  /* ----------------------------------------------------------------- sides */
  var SIDE_AXES = [
    [rx("მარცხ|\\bleft\\b|\\blh\\b|martskh|marcx|лев(?:ый|ая|ую|ой|ые|ого|ому|ом|ое|ых)(?![\\p{L}])|слева|\\bdriver(?:'?s)?(?:\\s+side)?\\b"), 'L',
      rx("მარჯვ|\\bright\\b|\\brh\\b|marjv|прав(?:ый|ая|ую|ой|ые|ого|ому|ом|ое|ых)(?![\\p{L}])|справа|\\bpassenger(?:'?s)?(?:\\s+side)?\\b"), 'R'],
    [rx('წინა(?!სწარ|აღმდეგ|დადებ|პირობ|მძღოლ)|\\bfront\\b|передн|(?<![а-яё])перед(?![а-яё])|(?<![a-z])(?:wina|tsina|cina)(?![a-z])'), 'front',
      rx('უკანა(?!სკნელ)|\\brear\\b|\\bback\\b|задн|(?<![а-яё])зад(?![а-яё])|(?<![a-z])ukana(?![a-z])'), 'rear'],
    [rx('ზედა(?!პირ|მხედ|მეტ)|\\bupper\\b|\\btop\\b|верхн|(?<![a-z])zeda(?![a-z])'), 'upper',
      rx('ქვედა|\\blower\\b|\\bbottom\\b|нижн|(?<![a-z])qveda(?![a-z])'), 'lower']
  ];
  var BOTH_SIDES = rx('ორივე|\\bboth\\b|обе(?![\\p{L}])|оба(?![\\p{L}])|обеих|წყვილ|комплект|\\bpair\\b|\\bset\\b');
  var SIDE_WORD = 'მარცხენა|მარჯვენა|მარცხნივ|მარჯვნივ|წინა|უკანა|ზედა|ქვედა|left|right|front|rear|back|upper|lower|лев[а-яё]*|прав[а-яё]*|передн[а-яё]*|задн[а-яё]*|верхн[а-яё]*|нижн[а-яё]*';
  var NEGATED_SIDE = rx('(?:' + SIDE_WORD + ')[ა-ჰ]*\\s*,?\\s*(?:კი\\s+)?(?:არა(?![ა-ჰ])(?!\\s*\\?)|არ\\s+(?:მინდა|მჭირდება))|(?<![\\p{L}])(?:не|not(?:\\s+the)?|no)\\s+(?:' + SIDE_WORD + ')(?:\\s+one)?', 'giu');
  var SIDE_TOKENS = rx('(?<![\\p{L}])(?:' + SIDE_WORD + '|მარცხ|მარჯვ|слева|справа|перед|зад|lh|rh|martskh|marcx|marjv|wina|tsina|cina|ukana|zeda|qveda|driver|passenger)[\\p{L}]*', 'giu');
  /** { side: 'L'|'R'|'both'|null, position: 'front'|'rear'|'both'|null, level } from a text. */
  function axesIn(raw) {
    var t = String(raw).normalize('NFC').replace(NEGATED_SIDE, ' ');
    var out = { side: null, position: null, level: null };
    var keys = ['side', 'position', 'level'];
    for (var i = 0; i < SIDE_AXES.length; i++) {
      var a = SIDE_AXES[i][0].test(t), b = SIDE_AXES[i][2].test(t);
      if (a && b) out[keys[i]] = 'both';
      else if (a) out[keys[i]] = SIDE_AXES[i][1];
      else if (b) out[keys[i]] = SIDE_AXES[i][3];
    }
    if (BOTH_SIDES.test(t) && out.side === null) out.side = 'both';
    return out;
  }

  /* --------------------------------------------------------------- quality */
  var ORIG_WORD = '(?:ორიგინალ|ორიჯინალ|оригинал|original|genuine|oem|originali)';
  var ALT_WORD = '(?:ანალოგ|არაორიგინალ|ჩინურ|ჩინეთის|tong\\s*yang|ტონგ\\s*იანგ|аналог|неоригинал|копи|китай|aftermarket|analog|copy|replica|non[- ]?original|araoriginal)';
  var COMPARE = rx(ORIG_WORD + '[\\p{L}-]*[?]?\\s*(?:თუ|ან|და|или|и|or|and|vs\\.?|versus|,)\\s+(?:[\\p{L}]+\\s+)?' + ALT_WORD + '|' + ALT_WORD + '[\\p{L}-]*[?]?\\s*(?:თუ|ან|და|или|и|or|and|vs\\.?|versus|,)\\s+(?:[\\p{L}]+\\s+)?' + ORIG_WORD);
  var NEG = '(?:არა|არ\\s+მინდა|არ\\s+მჭირდება|не|not|no|без)';
  var ORIG_NEGATED = rx(NEG + '\\s+' + ORIG_WORD + '|' + ORIG_WORD + '[\\p{L}-]*\\s*,?\\s*' + NEG + '(?![\\p{L}])(?!\\s*\\?)(?!\\s+' + ALT_WORD + ')');
  var ALT_NEGATED = rx(NEG + '\\s+' + ALT_WORD + '|' + ALT_WORD + '[\\p{L}-]*\\s*,?\\s*' + NEG + '(?![\\p{L}])(?!\\s*\\?)(?!\\s+' + ORIG_WORD + ')');
  var QUALITY_WORDS = rx('tong\\s*yang|ტონგ\\s*იანგ[ა-ჰ]*|тонг\\s*янг[а-яё]*|(?<![a-z])gordon(?![a-z])|გორდონ[ა-ჰ]*|гордон[а-яё]*|' + ORIG_WORD + '[\\p{L}]*|' + ALT_WORD + '[\\p{L}]*|(?<![a-z])(?:china|chinese)(?![a-z])', 'giu');
  var Q_GORDON = rx('(?<![a-z])gordon(?![a-z])|გორდონ|гордон');
  var Q_CHINA = rx('ჩინურ|ჩინეთ|китай|(?<![a-z])(?:china|chinese)(?![a-z])');
  var Q_ANALOG = rx('არაორიგინალ|ანალოგ|неоригинал|аналог|aftermarket|non.original|(?<![a-z])(?:analog(?:i|ia)?|araoriginal\\w*|copy|replica)(?![a-z])');
  var Q_ORIG = rx('ორიგინალ|ორიჯინალ|оригинал|\\b(?:original|orginal|genuine|oem)\\b|(?<![a-z])(?:originali|orginali)(?![a-z])');
  /** Customer quality wish: 'orig' | 'tong' | 'gordon' | 'china' | 'analog' (= any non-original) | null (none / a comparison). */
  function queryQuality(text) {
    var t = String(text).normalize('NFC');
    var origNo = ORIG_NEGATED.test(t), altNo = ALT_NEGATED.test(t);
    if (altNo && !origNo && rx(ORIG_WORD).test(t)) return 'orig';
    if (origNo && !altNo && rx(ALT_WORD).test(t)) return 'analog';
    if (COMPARE.test(t)) return null;
    if (/tong\s*yang|ტონგ\s*იანგ|тонг\s*янг/iu.test(t)) return 'tong';
    if (Q_GORDON.test(t)) return 'gordon';
    if (Q_CHINA.test(t)) return 'china';
    if (Q_ANALOG.test(t)) return 'analog';
    if (Q_ORIG.test(t)) return 'orig';
    return null;
  }
  var VENDOR_QUALITY = { 'orginal': 'orig', 'original': 'orig', 'oem': 'orig', 'tong yang': 'tong', 'gordon': 'gordon', 'china': 'china' };
  function productQuality(vendor, title, tags) {
    var v = VENDOR_QUALITY[fold(vendor).trim()];
    if (v) return v;
    var q = queryQuality(title + ' ' + tags.join(' '));
    return q === 'analog' ? 'china' : q;
  }
  function qualityFits(want, have) {
    if (!want) return true;
    if (want === 'analog') return have === 'china' || have === 'tong' || have === 'gordon';
    return want === have;
  }

  /* ------------------------------------------------------------------- LED */
  var LED = rx('(?<![a-z])(?:full\\s*-?\\s*)?led(?![a-z])|ლედ', 'iu');
  var Q_LED = rx('(?<![a-z])led(?![a-z])|(?<![а-яё])лед(?![а-яё])', 'iu');
  var FULL_LED = /full\s*-?\s*led/iu;
  var PLAIN_LAMP = rx('ჩვეულებრივ|ჰალოგენ|halogen|галоген|обычн|стандартн|(?<![a-z])(?:regular|standard|normal|basic|non[- ]?led)(?![a-z])');
  var NO_LED = rx('(?:led|ლედ)[\\p{L}-]*\\s*,?\\s+(?:არა(?![ა-ჰ])|არ\\s+(?:მინდა|მჭირდება))|(?:led|ლედ)[\\p{L}-]*\\s+გარეშე|(?<![\\p{L}])(?:без|не|not|without|no|non)[\\s-]+(?:led|лед)');
  var LAMP_WORD = rx('ფარ|სანათ|მაშუქ|სტოპ|ფანარ|фар|фонар|стоп|lamp|light');
  var LED_WORDS = rx('(?<![a-z])(?:full\\s*-?\\s*)?led(?![a-z])|ლედ[ა-ჰ]*|лед(?![а-яё])|ჩვეულებრივ[ა-ჰ]*|ჰალოგენ[ა-ჰ]*|halogen|галоген[а-яё]*|обычн[а-яё]*|стандартн[а-яё]*|(?<![a-z])(?:regular|standard|normal|basic|non[- ]?led)(?![a-z])', 'giu');

  /* -------------------------------------------------------------- stop words */
  var STOPWORDS = new Set(('მინდა მჭირდება გჭირდებათ გაქვთ გვაქვს არის არი ვარ თუ და ან რა ღირს ფასი ფასად ფასზე ცალი ერთი ორი სამი ' +
    'ახალი მეორადი ავტომობილი ავტომობილის ავტომობილისთვის მანქანა მანქანის მანქანისთვის ნაწილი ნაწილები ნაწილის მოდელი მოდელის ' +
    'წლის წელი წლიანი წლების გამარჯობა გამარჯობათ გთხოვთ მადლობა კი არა ხო აქვს მაქვს ვეძებ მაინტერესებს საჭიროა სჭირდება ' +
    'გამოსაცვლელი ვიყიდი ყიდვა შეძენა შეგიძლიათ შეიძლება გავიგო დამეხმარეთ ვნახო ნახვა სად როგორ რამდენი ხომ თქვენ ჩემი ჩემს ' +
    'ამ ეს იმ რომ ის არსებობს ხართ მაღაზია საიტზე კატალოგში თქვენთან მითხარით მაჩვენეთ მაჩვენე ორივე მხარე მხარეს მარტო მხოლოდ ' +
    'ასევე კიდევ სხვა იგივე ისეთი რომელი რომელიც უნდა გინდა წლიან წლიანის გამოშვების ვერსია ვერსიის თაობა თაობის ვინ რაღაც რამე ' +
    'დიახ აღარ ჯერ გქონდეთ გექნებათ იქნება არ ვერ ნუ ეგ ეგენი ' +
    'хочу нужен нужна нужно есть для на цена сколько стоит купить ли у вас машина машину автомобиль деталь год года привет здравствуйте ' +
    'пожалуйста мне моей мой моя новый новая и или а в с по что как где это эта этот оба обе ' +
    'i want need the a an for my car part parts price how much do you have is there please hello hi buy of and or in on to with year new used model both side looking find show me it this that').split(' '));
  var STOP_STEM = /^(?:მოდელ|მანქან|ავტომობილ|ნაწილ|თაობ|ვერსი|წლ(?:ის|ების|იან)|გამოშვებ|მაღაზი|კატალოგ|საიტ|ვარიანტ|შეთავაზებ|დეტალ|запчаст|модел|машин|автомобил|детал|вариант)/u;
  var CONNECTORS = rx('^(?:\\+|&|და|ან|и|или|and|or|-|\\/)$');
  function stemWord(word) { return word.length >= 5 ? word.slice(0, Math.max(4, word.length - 2)) : word; }

  /* ------------------------------------------------------------- the index */
  /**
   * rows: [{ id, handle, title (display), titleKa, sku, vendor, type, tags[], price, compare, available, img, imgW }]
   * Attributes are read from the Georgian source title (the one the chat and the owner write), then tags.
   */
  function buildIndex(rows, attrs) {
    var state = startIndex();
    for (var i = 0; i < rows.length; i++) addRow(state, rows[i], attrs && attrs[i]);
    return finishIndex(state);
  }
  /**
   * The same index without a long task: attributes are computed in slices, yielding to the page between them.
   * 1.1.0: a slice ends after `budget` ms of work (default 10) as well as after `slice` rows (default 60). A fixed
   * 60 rows took 50–95 ms per slice on a throttled phone (PSI Search TBT 4,320 ms); the clock is checked after every
   * row, so a slice is the budget plus at most one row. Same rows, same order, same index — only the yield points move.
   */
  var BUILD_BUDGET_MS = 10;
  function buildIndexAsync(rows, attrs, slice, budget) {
    var state = startIndex(), i = 0, n = slice || 60, ms = budget > 0 ? budget : BUILD_BUDGET_MS;
    return new Promise(function (resolve, reject) {
      function step() {
        try {
          var end = Math.min(rows.length, i + n), started = now();
          while (i < end) {
            addRow(state, rows[i], attrs && attrs[i]);
            i++;
            if (now() - started >= ms) break;
          }
          if (i < rows.length) yieldTask(step); else resolve(finishIndex(state));
        } catch (err) { reject(err); }
      }
      step();
    });
  }
  function now() { return typeof performance !== 'undefined' && performance && typeof performance.now === 'function' ? performance.now() : Date.now(); }
  // postTask where it exists (Chrome, Firefox); else a MessageChannel in the browser — Safari clamps nested
  // setTimeout(0) to ≥ 4 ms, which on ~100 slices would add ~0.4 s; setTimeout stays the fallback (and in Node).
  var YIELD_Q = [], YIELD_PORT = null;
  function yieldTask(fn, priority) {
    var sch = typeof scheduler !== 'undefined' && scheduler && typeof scheduler.postTask === 'function' ? scheduler : null;
    if (sch) { sch.postTask(fn, { priority: priority || 'user-visible' }); return; }
    if (priority === 'background') { // never ahead of the index build on browsers without postTask
      if (typeof requestIdleCallback === 'function') requestIdleCallback(function () { fn(); }, { timeout: 1000 }); else setTimeout(fn, 0);
      return;
    }
    if (typeof window !== 'undefined' && typeof MessageChannel === 'function') {
      if (!YIELD_PORT) {
        var ch = new MessageChannel();
        ch.port1.onmessage = function () { var f = YIELD_Q.shift(); if (f) f(); };
        YIELD_PORT = ch.port2;
      }
      YIELD_Q.push(fn); YIELD_PORT.postMessage(0);
      return;
    }
    setTimeout(fn, 0);
  }
  /**
   * Compiles the engine's start-up patterns ahead of the first query, in time-boxed slices. A regular expression is
   * compiled on its first use (and compiled again, optimized, on its second); on a throttled phone the ~260 part /
   * model patterns made the first query a 150–300 ms task. Running each twice on a short text changes no state
   * (lastIndex is reset) and no result — it only moves that work into slices, ideally while the index downloads.
   * It runs at background priority and nothing waits for it: whatever is not warm yet compiles on use, as before.
   */
  var warmed = null;
  function warmRegexes() {
    if (warmed) return warmed;
    var i = 0, sample = 'Tucson 2020 ტუსონი წინა ფარი тусан фара';
    warmed = new Promise(function (resolve) {
      function step() {
        var started = now();
        while (i < WARM_LIST.length) {
          var re = WARM_LIST[i++];
          try { re.lastIndex = 0; re.test(sample); re.lastIndex = 0; re.test(sample); } catch (e) { /* never fatal */ }
          re.lastIndex = 0;
          if (now() - started >= BUILD_BUDGET_MS) break;
        }
        if (i < WARM_LIST.length) yieldTask(step, 'background'); else resolve();
      }
      yieldTask(step, 'background');
    });
    return warmed;
  }
  function startIndex() { return { items: [], skuMap: new Map(), carried: new Set(), vocab: new Map(), ids: new Set() }; }
  function addRow(state, r, cachedA) {
    if (!r || state.ids.has(r.id)) return;
    state.ids.add(r.id);
    var item = describe(r, cachedA);
    state.items.push(item);
    item.skus.forEach(function (sku) { var list = state.skuMap.get(sku); if (list) list.push(item); else state.skuMap.set(sku, [item]); });
    item.a.models.forEach(function (m) { state.carried.add(m); });
    wordsOf(item.titleKa + ' ' + item.title).forEach(function (w) { if (w.length >= 4 && !/\d/.test(w)) state.vocab.set(w, (state.vocab.get(w) || 0) + 1); });
  }
  function finishIndex(state) {
    return { v: VERSION, items: state.items, byId: new Map(state.items.map(function (it) { return [it.id, it]; })), skuMap: state.skuMap, carried: state.carried, vocab: state.vocab, builtAt: Date.now() };
  }

  var TAG_MEMO = new Map();
  function describe(r, cachedA) {
    var titleKa = String(r.titleKa || r.title || '');
    var title = String(r.title || titleKa);
    var tags = Array.isArray(r.tags) ? r.tags.map(String) : [];
    // variant SKUs arrive joined by „|“ (a SKU may itself contain a space: „86300-M6EA0 G“)
    var skus = uniq(String(r.sku || '').split('|').map(normSku).filter(function (x) { return x.length >= 3; }));
    var text = clean([titleKa, title !== titleKa ? title : '', tags.join(' '), r.type || '', r.vendor || '', String(r.sku || '').replace(/\|/g, ' ')].join(' '), 2000);
    return {
      id: r.id, handle: String(r.handle || ''), title: title, titleKa: titleKa, sku: String(r.sku || ''), skus: skus,
      vendor: String(r.vendor || ''), type: String(r.type || ''), tags: tags,
      price: Number(r.price) || 0, compare: Number(r.compare) || 0, available: r.available !== false && r.available !== 0,
      img: String(r.img || ''), imgW: Number(r.imgW) || 0, order: Number(r.order) || 0,
      a: cachedA && cachedA.v === VERSION ? cachedA : attributes(titleKa, tags, r), text: text
    };
  }
  /** Compatibility attributes of one product (pure: title + tags + type + vendor → attributes; cacheable per VERSION). */
  function attributes(titleKa, tags, r) {
    var nt = titleKa.normalize('NFC');
    // models with their own ranges: the title's models get the title's ranges; a tag „Model YYYY-YYYY“ adds
    // a model the title does not name, or a range for a title model that carries none.
    var modelRanges = {};
    var titleModels = directModels(nt), titleRanges = rangesIn(nt);
    titleModels.forEach(function (m) { modelRanges[m] = titleRanges.slice(); });
    var tagOnly = {};
    tags.forEach(function (tag) {
      var memo = TAG_MEMO.get(tag);
      if (!memo) { memo = { m: directModels(tag), r: rangesIn(tag) }; if (TAG_MEMO.size < 5000) TAG_MEMO.set(tag, memo); }
      var tm = memo.m, tr = memo.r;
      tm.forEach(function (m) {
        if (!has(modelRanges, m)) { modelRanges[m] = tr.slice(); tagOnly[m] = true; }
        else if (tagOnly[m] || !modelRanges[m].length) modelRanges[m] = mergeRanges(modelRanges[m], tr);
      });
    });
    var models = Object.keys(modelRanges);
    var allRanges = [];
    models.forEach(function (m) { allRanges = mergeRanges(allRanges, modelRanges[m]); });
    if (!models.length) allRanges = titleRanges;
    var pa = analyzeParts(nt);
    var partList = namedParts(nt, pa);
    var partCanon = pa.head ? pa.head.canon : (PRODUCT_TYPE_PARTS[String(r.type || '').trim()] || null);
    if (partList.length > 1 && partCanon && partList.indexOf(partCanon) < 0) partList.unshift(partCanon);
    var partOf = pa.parent;
    var ax = axesIn(nt);
    var tagAx = axesIn(tags.join(' '));
    // the title and a tag naming opposite sides: the data contradicts itself — never shown as a sure fit
    if ((ax.side === 'L' || ax.side === 'R') && (tagAx.side === 'L' || tagAx.side === 'R') && ax.side !== tagAx.side) ax.side = 'conflict';
    if (ax.side === null) ax.side = tagAx.side;
    if (ax.position === null) ax.position = tagAx.position;
    if (partCanon === 'ფარი' && ax.position === 'rear') partCanon = 'უკანა ფარი';
    if (partList.length > 1) partList = partList.map(function (x) { return x === 'ფარი' && ax.position === 'rear' ? 'უკანა ფარი' : x; });
    var implied = PART_BY.get(partCanon);
    var position = ax.position || (implied && implied.position) || null;
    var effective = position === null && (partCanon === 'ფრთა' || partCanon === 'ფარი') && !partOf ? 'front' : position;
    return {
      v: VERSION, models: models, modelRanges: modelRanges, ranges: allRanges,
      brand: models.length ? (uniq(models.map(brandOf)).length === 1 ? brandOf(models[0]) : null) : brandIn(nt + ' ' + tags.join(' ')),
      part: partCanon, parts: partList.length > 1 ? partList : (partCanon ? [partCanon] : []), partOf: partOf, genitive: pa.genitive,
      side: ax.side, position: effective, level: ax.level,
      quality: productQuality(r.vendor || '', nt, tags), led: LED.test(nt), fullLed: FULL_LED.test(nt),
      latest: allRanges.reduce(function (m, x) { return Math.max(m, x.to); }, 0)
    };
  }
  function mergeRanges(a, b) {
    var out = a.slice();
    b.forEach(function (r) { if (!out.some(function (x) { return x.from === r.from && x.to === r.to; })) out.push({ from: r.from, to: r.to }); });
    return out;
  }

  /* ---------------------------------------------------------- query parsing */
  var HEADLIGHT_EN = rx('\\bhead\\s?(?:light|lamp)s?\\b');
  /**
   * Equipment words a customer types in any language while the titles say it in Georgian („с парктрониками“ →
   * „დახვრეტილი“). A feature asked for must be in the title; one ruled out („без…“, „…გარეშე“) must not.
   */
  var FEATURES = [
    { key: 'parking', q: rx('პარკტრონიკ|პარკინგ|დახვრეტ|სენსორ(?:ით|ებით|იან)|парктрон|паркт|датчик|сенсор|parking|sensor|perforat|(?<![a-z])holes?(?![a-z])'),
      item: rx('დახვრეტ|პარკინგ|პარკტრონიკ|სენსორ(?:ით|ებით|იან)|датчик|парктрон|parking|sensor'),
      itemNeg: rx('(?:პარკინგ|სენსორ|პარკტრონიკ|დახვრეტ)[ა-ჰ]*\\s+გარეშე|без\\s+(?:парктрон|датчик|отверст)|without\\s+(?:parking|sensor|holes)'),
      words: { ka: 'დახვრეტილი', ru: 'с парктроником', en: 'parking sensor holes' } },
    { key: 'camera', q: rx('კამერ|камер|camera'), item: rx('კამერ|камер|camera'), itemNeg: rx('კამერ[ა-ჰ]*\\s+გარეშე|без\\s+камер|without\\s+camera'), words: { ka: 'კამერით', ru: 'с камерой', en: 'camera' } },
    { key: 'radar', q: rx('რადარ|დისტრონიკ|радар|дистроник|radar|distronic'), item: rx('რადარ|დისტრონიკ|радар|дистроник|radar|distronic'), itemNeg: rx('(?:რადარ|დისტრონიკ)[ა-ჰ]*\\s+გარეშე|без\\s+(?:радар|дистроник)|without\\s+(?:radar|distronic)'), words: { ka: 'რადარით', ru: 'с радаром', en: 'radar' } },
    { key: 'hybrid', q: rx('ჰიბრიდ|гибрид|hybrid'), item: rx('ჰიბრიდ|гибрид|hybrid'), itemNeg: null, words: { ka: 'ჰიბრიდის', ru: 'гибрид', en: 'hybrid' } }
  ];
  var FEATURE_NEG = rx('(?:გარეშე|без|without|no|non)');
  function featuresIn(text) {
    var want = [], not = [];
    FEATURES.forEach(function (f) {
      var m = f.q.exec(text);
      if (!m) return;
      var before = text.slice(Math.max(0, m.index - 12), m.index), after = text.slice(m.index, m.index + 40);
      var negated = /(?:без|without|no|non)[\s-]+$/iu.test(before) || /^[\p{L}-]*\s+გარეშე/u.test(after);
      (negated ? not : want).push(f.key);
    });
    return { want: want, not: not };
  }
  var FEATURE_WORDS = rx('(?:[\\p{L}]*(?:პარკტრონიკ|პარკინგ|დახვრეტ|სენსორ(?:ით|ებით|იან)|парктрон|паркт|датчик|сенсор|parking|sensor|perforat|კამერ|камер|camera|რადარ|დისტრონიკ|радар|дистроник|radar|distronic|ჰიბრიდ|гибрид|hybrid)[\\p{L}]*|(?<![a-z])holes?(?![a-z]))(?:\\s+გარეშე)?', 'giu');
  /** Narrower kinds inside one taxonomy part: a fender liner and an engine undercover are both „დამცავი“. */
  var SUBTYPES = [
    { q: rx('подкрыл|პადკრილ|ლოკერ|(?<![a-z])(?:fender\\s+)?liners?(?![a-z])|ფრთის\\s+(?:ქვედა\\s+)?(?:დამცავ|საფარ)|крыл\\S*\\s+защит|защит\\S*\\s+крыл'), item: rx('ფრთ|крыл|პადკრილ|подкрыл|ლოკერ|liner|fender|კრილ') },
    { q: rx('ძრავის\\s+(?:ქვედა\\s+)?(?:დამცავ|საფარ)|კარტერის\\s+დამცავ|защит\\S*\\s+(?:двигат|картер)|(?:двигат|картер)\\S*\\s+защит|engine\\s+(?:guard|cover|undercover|shield)|skid\\s+plate'), item: rx('ძრავ|двигат|engine|კარტერ|картер') }
  ];
  function parseQuery(raw, index) {
    var text = fold(raw, MAX_QUERY + 50);
    if (text.length > MAX_QUERY) text = text.slice(0, MAX_QUERY);
    // punctuation separates words („Tucson,2023,ფარი“); hyphens, dots, slashes and + stay (ranges, 2.5, kits)
    text = text.replace(PUNCT, ' ').replace(/\s+/g, ' ').trim();
    var intent = {
      raw: String(raw == null ? '' : raw).slice(0, MAX_QUERY), text: text, empty: !text,
      models: [], modelWords: [], fuzzy: null, brand: null, years: [], range: null, parts: [], part: null, partOf: null,
      side: null, position: null, positionStated: false, level: null, quality: null, led: null, excludeLed: false,
      terms: [], skuCands: [], vin: false, foreign: null, uncarried: [], unsupported: false, genitive: false, subtype: null,
      features: [], noFeatures: []
    };
    if (!text) return intent;
    var tokens = text.split(' ').slice(0, MAX_TOKENS);
    text = tokens.join(' ');
    intent.text = text;
    if (VIN_RE.test(text.toUpperCase()) && /\d/.test(text) && /[a-z]/i.test(text)) {
      var vinTok = tokens.filter(function (t) { return t.length === 17 && /\d/.test(t) && /[a-z]/i.test(t); });
      if (vinTok.length) { intent.vin = true; tokens = tokens.filter(function (t) { return vinTok.indexOf(t) < 0; }); text = tokens.join(' '); }
    }
    // SKU candidates: the whole query, each token, adjacent pairs/triples („ka 04271 bc“)
    var cands = [];
    var whole = normSku(text);
    if (tokens.length <= 4 && skuLike(whole)) cands.push(whole);
    for (var i = 0; i < tokens.length; i++) {
      for (var n = 1; n <= 3 && i + n <= tokens.length; n++) {
        var c = normSku(tokens.slice(i, i + n).join(''));
        if (skuLike(c) && cands.indexOf(c) < 0) cands.push(c);
      }
    }
    intent.skuCands = cands;

    // lamp „ლედი“ is the LED technology, not the daytime-running-light part
    if (LAMP_WORD.test(text)) text = text.replace(/ლედ[ა-ჰ]*/gu, ' led ');
    // "bumper cover/fascia" is the (US) name of the bumper itself
    text = text.replace(/\bbumper\s+(?:cover|fascia|skin)s?\b/g, 'bumper');
    var feats = featuresIn(text);
    intent.features = feats.want; intent.noFeatures = feats.not;
    var yr = queryYears(text);
    intent.years = yr.years; intent.range = yr.range;
    var carried = index ? index.carried : null;
    var models = directModels(text);
    if (!models.length) {
      var fz = fuzzyModel(text, carried);
      if (fz) { models = [fz.model]; intent.fuzzy = fz; }
    }
    intent.models = models;
    if (carried && carried.size) {
      intent.uncarried = models.filter(function (m) { return !carried.has(m); });
      intent.models = models.filter(function (m) { return carried.has(m); });
    }
    intent.brand = brandIn(text);
    if (!models.length && FOREIGN) {
      var fm = FOREIGN.exec(text);
      if (fm) intent.foreign = fm[0].trim();
    }
    var pa = analyzeParts(text);
    var named = namedParts(text, pa);
    intent.part = pa.head ? pa.head.canon : null;
    intent.parts = named.length > 1 ? named : (intent.part ? [intent.part] : []);
    intent.partOf = named.length > 1 ? null : pa.parent;
    // 1.2.0: the bumper grille is named with its own parent's words („ბამპერის ცხაურა“, „решётка бампера“, „bumper
    // grille“) — those words name the part, they are no parent condition (the query found 2 of Kona's 5 grilles)
    if (intent.part && INHERENT_PARENT[intent.part] && INHERENT_PARENT[intent.part].indexOf(intent.partOf) >= 0) intent.partOf = null;
    intent.genitive = pa.genitive;
    for (var st = 0; st < SUBTYPES.length; st++) if (SUBTYPES[st].q.test(text)) { intent.subtype = st; break; }
    var ax = axesIn(text);
    intent.side = ax.side === 'both' ? null : ax.side;
    intent.position = ax.position === 'both' ? null : ax.position;
    // "headlight"/"head lamp" names the front lamp itself
    if (intent.position === null && HEADLIGHT_EN.test(text)) intent.position = 'front';
    intent.positionStated = intent.position !== null;
    intent.level = ax.level === 'both' ? null : ax.level;
    if (intent.part === 'ფარი' && intent.position === 'rear') { intent.part = 'უკანა ფარი'; intent.parts = intent.parts.map(function (p) { return p === 'ფარი' ? 'უკანა ფარი' : p; }); }
    if (!intent.positionStated && intent.part && intent.parts.length === 1) { var ip = PART_BY.get(intent.part); intent.position = ip && ip.position || null; }
    intent.quality = queryQuality(text);
    if (NO_LED.test(text) || (PLAIN_LAMP.test(text) && (LAMP_WORD.test(text) || intent.part === 'ფარი' || intent.part === 'უკანა ფარი'))) intent.excludeLed = true;
    else if (FULL_LED.test(text)) intent.led = 'full';
    else if (Q_LED.test(text)) intent.led = 'led';
    intent.terms = contentTerms(text, intent);
    intent.unsupported = !intent.models.length && !intent.parts.length && !intent.terms.length && !intent.skuCands.length && !intent.years.length && !intent.brand && !intent.quality && !intent.led && !intent.side && !intent.positionStated && !intent.features.length;
    return intent;
  }

  /** The customer's own words that name no model, year, side, part, quality or SKU („ჰიბრიდის“, „limited“, „2.5“). */
  function contentTerms(text, intent) {
    var t = text.replace(FEATURE_WORDS, ' ');
    t = stripPartNames(stripModelNames(t));
    t = t.replace(QUALITY_WORDS, ' ').replace(LED_WORDS, ' ').replace(SIDE_TOKENS, ' ');
    var out = [], words = t.split(/[\s,;:!?()"'«»„“”]+/u);
    for (var i = 0; i < words.length && out.length < 6; i++) {
      var w = words[i].replace(/^[-./+&]+|[-./+&]+$/g, '');
      if (!w || CONNECTORS.test(w) || STOPWORDS.has(w) || STOP_STEM.test(w)) continue;
      if (/^(?:19|20)\d{2}(?:[-–—](?:19|20)?\d{2})?$/.test(w) || /^\d{2}(?:-?(?:წ|იან|год|г))/u.test(w) || /^\d{1,2}$/.test(w)) continue;
      if (intent.skuCands.indexOf(normSku(w)) >= 0 && skuLike(normSku(w))) continue;
      if (w.length < 2 || (w.length < 3 && !/^[a-z]{2}$/.test(w))) continue;
      if (partTypeIn(w) && partTypeIn(w).cls !== 'C') continue;
      if (intent.fuzzy && w === intent.fuzzy.word) continue;
      var stem = w.length >= 5 && /\p{L}/u.test(w) && !/\d/.test(w) ? stemWord(w) : w;
      if (!out.some(function (o) { return o.stem === stem; })) out.push({ word: w, stem: stem, short: stem.length < 4 });
    }
    return out;
  }

  var TERM_RE_CACHE = new Map();
  function termRe(term) {
    var key = term.stem + (term.short ? '|s' : '');
    var re = TERM_RE_CACHE.get(key);
    if (!re) {
      var esc = term.stem.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&');
      re = term.short ? rx('(?<![\\p{L}\\p{N}])' + esc + '(?![\\p{L}\\p{N}])', 'iu') : rx(esc, 'iu');
      TERM_RE_CACHE.set(key, re);
    }
    return re;
  }
  function termIn(term, item) { return termRe(term).test(item.text); }

  /* ------------------------------------------------------------ evaluation */
  var LAMPS = ['ფარი', 'უკანა ფარი'];
  // parts a customer of the first one usually also wants to see (listed apart, never as the same part)
  var SIBLINGS = { 'ცხაურა': ['ბამპერის ცხაურა'], 'ბამპერის ცხაურა': ['ცხაურა'], 'ფარი': ['სანისლე ფარი', 'დღის სინათლე'], 'ფრთა': ['დამცავი'] };
  function isSibling(want, part) { return want.some(function (p) { return (SIBLINGS[p] || []).indexOf(part) >= 0; }); }
  function partFits(intent, a) {
    var want = intent.parts;
    for (var i = 0; i < want.length; i++) {
      var p = want[i];
      if (a.parts.indexOf(p) >= 0) return true;
      // bare „ფარი“ covers the whole lamp family: the rear lamps are listed apart, not hidden
      if (p === 'ფარი' && !intent.positionStated && a.parts.indexOf('უკანა ფარი') >= 0) return true;
    }
    return false;
  }
  /** 'match' | 'unknown' | 'related' | 'quality' | 'reject' with a score and the reasons. */
  function evaluate(intent, item) {
    var a = item.a, score = 0, unknown = [], related = false;
    if (intent.models.length) {
      if (!a.models.length) unknown.push('model');
      else if (!a.models.some(function (m) { return intent.models.indexOf(m) >= 0; })) return reject('model');
      else score += 30;
    } else if (intent.brand) {
      if (a.models.some(function (m) { return brandOf(m) === intent.brand; }) || (!a.models.length && a.brand === intent.brand)) score += 10;
      else if (!a.models.length && !a.brand) unknown.push('brand');
      else return reject('brand');
    }
    if (intent.years.length) {
      var ranges = [];
      if (intent.models.length) a.models.forEach(function (m) { if (intent.models.indexOf(m) >= 0) ranges = ranges.concat(a.modelRanges[m] || []); });
      else ranges = a.ranges;
      if (!ranges.length) unknown.push('year');
      else if (!yearsFit(ranges, intent.years)) return reject('year');
      else score += 15;
    }
    if (intent.parts.length) {
      if (partFits(intent, a)) {
        // a piece of the part („ბამპერის მარცხენა ნაწილი“, „…ბამპერის დაბოლოება“) is listed with the related parts
        // unless the customer asked for a piece too
        if (a.genitive && !intent.genitive && a.parts.length <= 1) related = true;
        if (intent.subtype !== null && intent.subtype !== undefined && !SUBTYPES[intent.subtype].item.test(item.text)) return reject('subtype');
        score += 40;
        if (!a.genitive) score += 5;
        if (!intent.level && a.level === null) score += 2;
        if (intent.partOf) {
          if (a.partOf && a.partOf !== intent.partOf) return reject('part');
          if (a.partOf === intent.partOf) score += 10;
        }
        if (intent.parts.indexOf('ფარი') >= 0 && !intent.positionStated && a.part === 'ფარი') score += 6;
      } else if ((a.partOf && intent.parts.indexOf(a.partOf) >= 0 && !intent.partOf) || isSibling(intent.parts, a.part)) {
        related = true;
      } else if (!a.part && intent.parts.some(function (p) { return termIn({ stem: stemWord(fold(p).split(' ').pop()), short: false }, item); })) {
        unknown.push('part');
      } else return reject('part');
    }
    if (intent.side === 'L' || intent.side === 'R') {
      if (a.side === intent.side || a.side === 'both') score += 8;
      else if (a.side === 'conflict') unknown.push('side');
      else if (a.side === null) {
        var info = PART_BY.get(a.part);
        if (info && info.sided) unknown.push('side');
      } else return reject('side');
    }
    if (intent.position === 'front' || intent.position === 'rear') {
      if (a.position === intent.position || a.position === 'both') score += 4;
      else if (a.position !== null && (intent.positionStated || !(intent.part === 'ფარი'))) return reject('position');
    }
    if (intent.level) {
      if (a.level === intent.level) score += 3;
      else if (a.level !== null) return reject('level');
      else unknown.push('level');
    }
    if (intent.led === 'full' && !a.fullLed) return reject('led');
    if (intent.led === 'led' && !a.led) return reject('led');
    if (intent.excludeLed && a.led) return reject('led');
    for (var f = 0; f < FEATURES.length; f++) {
      var feat = FEATURES[f];
      var hasIt = feat.item.test(item.text) && !(feat.itemNeg && feat.itemNeg.test(item.text));
      if (intent.features.indexOf(feat.key) >= 0) { if (!hasIt) return reject('feature:' + feat.key); score += 5; }
      if (intent.noFeatures.indexOf(feat.key) >= 0 && hasIt) return reject('feature:' + feat.key);
    }
    for (var i = 0; i < intent.terms.length; i++) {
      if (!termIn(intent.terms[i], item)) return reject('term:' + intent.terms[i].word);
      score += 5;
    }
    var quality = !qualityFits(intent.quality, a.quality);
    if (!quality && intent.quality) score += 3;
    return {
      status: quality ? 'quality' : related ? 'related' : unknown.length ? 'unknown' : 'match',
      score: score, unknown: unknown
    };
    function reject(reason) { return { status: 'reject', score: 0, reason: reason }; }
  }

  /* --------------------------------------------------------------- search */
  var SORTS = ['relevance', 'price-ascending', 'price-descending', 'created-descending', 'created-ascending', 'title-ascending', 'title-descending'];
  function sortItems(list, sort) {
    var by = {
      'price-ascending': function (x, y) { return x.item.price - y.item.price; },
      'price-descending': function (x, y) { return y.item.price - x.item.price; },
      'created-descending': function (x, y) { return y.item.order - x.item.order || y.item.id - x.item.id; },
      'created-ascending': function (x, y) { return x.item.order - y.item.order || x.item.id - y.item.id; },
      'title-ascending': function (x, y) { return x.item.title.localeCompare(y.item.title); },
      'title-descending': function (x, y) { return y.item.title.localeCompare(x.item.title); }
    }[sort];
    list.sort(function (x, y) {
      var d = by ? by(x, y) : 0;
      if (d) return d;
      return (y.score - x.score) || (y.item.a.latest - x.item.a.latest) || (x.item.titleKa.length - y.item.titleKa.length) || (x.item.titleKa < y.item.titleKa ? -1 : x.item.titleKa > y.item.titleKa ? 1 : 0);
    });
    return list.map(function (x) { return x.item; });
  }

  /** Part words in every language, for correcting a typo the catalog titles cannot („решотка“ → „решетка“). */
  var PART_VOCAB = (function () {
    var out = new Map();
    PARTS.forEach(function (p) {
      [p.canon, p.label.ka, p.label.ru, p.label.en].forEach(function (label) {
        fold(label).split(/[^\p{L}]+/u).forEach(function (w) { if (w.length >= 5) out.set(w, 1); });
      });
    });
    ('решетка решётка бампер капот крыло фара фары фонарь дверь двери зеркало багажник подкрылок молдинг кронштейн телевизор радиатор ' +
      'противотуманка поворотник накладка заглушка усилитель отражатель диффузор headlight taillight bumper fender mirror grille bonnet ' +
      'ბამპერი კაპოტი ფრთა კარები სარკე საბარგული ცხაურა ეკრანი მოლდინგი ბრეკეტი სანისლე ამრეკლი დიფუზორი').split(' ').forEach(function (w) { out.set(w, 1); });
    return out;
  }());
  function bestCorrection(word, index) {
    if (word.length < 4 || /\d/.test(word)) return null;
    var budget = word.length >= 8 ? 2 : 1, best = null, bestCount = 0;
    function scan(count, v) {
      if (Math.abs(v.length - word.length) > budget || v === word) return;
      if (editDistance(word, v, budget) <= budget && count > bestCount) { best = v; bestCount = count; }
    }
    // a 4-letter word is only corrected to a part name („ფთრა“ → „ფრთა“); catalog words that short collide too often
    if (word.length >= 5) index.vocab.forEach(scan);
    if (!best) PART_VOCAB.forEach(scan);
    return best;
  }
  /** Every word inside the text spans that name the query's own parts. */
  function wordsOfParts(intent) {
    var out = new Set();
    intent.parts.concat(intent.partOf ? [intent.partOf] : []).forEach(function (canon) {
      var p = PART_BY.get(canon);
      if (!p) return;
      p.whole.lastIndex = 0;
      var m;
      while ((m = p.whole.exec(intent.text)) !== null) {
        m[0].split(WORDSEP).forEach(function (w) { if (w) out.add(w); });
        if (m[0].length === 0) p.whole.lastIndex += 1;
      }
    });
    return out;
  }
  /**
   * Words of the query that match nothing in the whole catalog: corrected when a catalog or part word is a typo
   * away (the query is then read again), else left out — and both are said to the customer.
   */
  function reconcile(intent, index) {
    var notes = [];
    if (!intent.terms.length) return { intent: intent, notes: notes };
    var text = intent.text, changed = false;
    var partWords = wordsOfParts(intent);
    intent.terms.forEach(function (term) {
      if (index.items.some(function (it) { return termIn(term, it); })) return;
      // a component named in another language („радиатор“, „shock absorber“) is already the part condition:
      // its words stay in the text (so the part survives the re-read) and only the free-text match is dropped
      if (partWords.has(term.word)) { changed = true; return; }
      var fixed = bestCorrection(term.word, index);
      var re = rx('(?<![\\p{L}\\p{N}])' + term.word.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&') + '(?![\\p{L}\\p{N}])', 'giu');
      text = text.replace(re, fixed ? fixed : ' ');
      changed = true;
      notes.push(fixed ? { code: 'term_corrected', from: term.word, to: fixed } : { code: 'term_dropped', word: term.word });
    });
    if (!changed) return { intent: intent, notes: notes };
    var next = parseQuery(text.replace(/\s+/g, ' ').trim(), index);
    next.raw = intent.raw;
    // a corrected word that still matches nothing is not searched for either
    next.terms = next.terms.filter(function (t) { return index.items.some(function (it) { return termIn(t, it); }); });
    return { intent: next, notes: notes };
  }
  function hasStructure(intent) { return intent.models.length > 0 || intent.parts.length > 0 || !!intent.brand || intent.features.length > 0; }
  function weakOnly(intent) {
    return !hasStructure(intent) && !intent.terms.length && (intent.years.length > 0 || !!intent.side || intent.positionStated || !!intent.level || !!intent.led || intent.excludeLed || !!intent.quality);
  }

  /**
   * opts.sort — the order; opts.lang — the language the page writes queries back in (refine chips, „remove“ chips,
   * no-results suggestions; default: the document's lang). 1.2.0: every chip count is the count of the search that
   * chip leads to (see verifyFacets). opts._inner — internal replay of such a search: results only, no chips.
   */
  function search(index, query, opts) {
    opts = opts || {};
    var inner = opts._inner === true;
    var intent = typeof query === 'string' || query == null ? parseQuery(query, index) : query;
    var result = { intent: intent, mode: 'intent', main: [], unknown: [], related: [], quality: [], notes: [], total: 0, facets: [], relax: [] };
    if (intent.empty) { result.mode = 'empty'; return result; }
    if (intent.vin) result.notes.push({ code: 'vin' });
    // exact SKU first — a code is the most precise question there is
    // the longest typed code that equals a SKU wins („HN 20067 A“ → HN20067A before HN20067)
    var skuHits = [], seen = new Map();
    intent.skuCands.forEach(function (c) { (index.skuMap.get(c) || []).forEach(function (it) { if (!seen.has(it.id)) { seen.set(it.id, 1000 + c.length); skuHits.push(it); } }); });
    if (!skuHits.length) {
      intent.skuCands.forEach(function (c) {
        if (c.length < 7 || (c.match(/\d/g) || []).length < 4) return;
        index.items.forEach(function (it) { if (!seen.has(it.id) && it.skus.some(function (x) { return x.indexOf(c) === 0; })) { seen.set(it.id, 500 + c.length); skuHits.push(it); } });
      });
      if (skuHits.length) result.notes.push({ code: 'sku_prefix' });
    } else result.notes.push({ code: 'sku_exact' });
    if (skuHits.length) {
      result.mode = 'sku';
      result.main = sortItems(skuHits.map(function (it) { return { item: it, score: seen.get(it.id) }; }), opts.sort);
      result.total = result.main.length;
      return result;
    }
    if (intent.foreign) { result.notes.push({ code: 'foreign_make', make: intent.foreign }); result.mode = 'none'; return result; }
    if (intent.uncarried.length && !intent.models.length) { result.notes.push({ code: 'model_not_carried', model: modelName(intent.uncarried[0]) }); result.mode = 'none'; return result; }
    if (intent.fuzzy && !intent.fuzzy.exact) result.notes.push({ code: 'model_corrected', from: intent.fuzzy.word, to: modelName(intent.fuzzy.model) });
    var rec = reconcile(intent, index);
    intent = rec.intent; result.intent = intent;
    result.notes = result.notes.concat(rec.notes);
    if (intent.years.length && intent.years.every(function (y) { return y < CATALOG_YEAR_FROM || y > CATALOG_YEAR_TO; })) result.notes.push({ code: 'year_out_of_catalog', year: intent.years[0], from: CATALOG_YEAR_FROM, to: CATALOG_YEAR_TO });
    if (!hasStructure(intent) && !intent.terms.length && !weakOnly(intent)) { result.mode = 'none'; return result; }
    var buckets = collect(index, intent);
    if (weakOnly(intent)) {
      // a year, a side or a quality alone names no part: ask for the model/part instead of listing hundreds
      result.mode = 'clarify';
      result.total = buckets.match.length;
      result.notes.push({ code: 'clarify' });
      if (!inner) lazy(result, 'facets', function () { return verifyFacets(index, result, facetsOf(buckets.match.map(function (x) { return x.item; }), result.intent).filter(function (f) { return f.kind === 'model' || f.kind === 'part'; }), opts); });
      return result;
    }
    if (!buckets.match.length && intent.terms.length && hasStructure(intent)) {
      // a refinement word that no otherwise-matching product carries is left out (and said so), not a reason for „nothing“
      var kept = [];
      intent.terms.forEach(function (t) {
        var trial = copyIntent(intent); trial.terms = kept.concat([t]);
        if (countMatches(index, trial) > 0) kept.push(t); else result.notes.push({ code: 'term_ignored', word: t.word });
      });
      intent = copyIntent(intent); intent.terms = kept; result.intent = intent;
      buckets = collect(index, intent);
    }
    result.main = sortItems(buckets.match, opts.sort);
    result.unknown = sortItems(buckets.unknown, opts.sort);
    result.related = sortItems(buckets.related, opts.sort);
    result.quality = sortItems(buckets.quality, opts.sort);
    result.total = result.main.length;
    if (intent.quality && !result.main.length && result.quality.length) result.notes.push({ code: 'quality_none', quality: intent.quality });
    if (inner) return result;
    // 1.2.0: chips and suggestions are worked out when they are read (the header popup never reads them)
    if (!result.main.length) lazy(result, 'relax', function () { return relaxations(index, result.intent, opts); });
    lazy(result, 'facets', function () { return verifyFacets(index, result, facetsOf(result.main, result.intent), opts); });
    return result;
  }
  function lazy(obj, key, make) {
    // R2 (F5): a frozen / sealed result still answers (the value is kept here), and a failure gives no chips — the
    // reading code (outside the caller's try around search()) never throws because of them
    var done = false, val;
    var fix = function (v) {
      val = v; done = true;
      try { Object.defineProperty(obj, key, { value: v, writable: true, configurable: true, enumerable: true }); } catch (e) { /* frozen */ }
      return v;
    };
    Object.defineProperty(obj, key, { configurable: true, enumerable: true, set: fix, get: function () {
      if (done) return val;
      var v;
      try { v = make(); } catch (e) {
        v = [];
        // kept for tests / debugging (not enumerable: spread, JSON and the UI do not see it)
        try { Object.defineProperty(obj, '_lazyErr', { value: e, configurable: true, writable: true }); } catch (e2) { /* frozen */ }
      }
      return fix(v);
    } });
  }
  function collect(index, intent) {
    var buckets = { match: [], unknown: [], related: [], quality: [] };
    for (var i = 0; i < index.items.length; i++) {
      var ev = evaluate(intent, index.items[i]);
      if (ev.status !== 'reject') buckets[ev.status].push({ item: index.items[i], score: ev.score, unknown: ev.unknown });
    }
    return buckets;
  }
  function countMatches(index, intent) {
    var n = 0;
    for (var i = 0; i < index.items.length; i++) if (evaluate(intent, index.items[i]).status === 'match') n++;
    return n;
  }

  /* ------------------------------------------- 1.2.0: chips are judged by the search they lead to */
  /*
   * A refine chip, a „remove“ chip and a no-results suggestion all end as TEXT (the field, ?q=) that is read again.
   * So each is judged by exactly that: the text is written in the page's language and searched, and the chip shows
   * that search's own count (L04 — the count used to be products carrying the exact value, not what the click
   * finds). A chip whose search finds nothing, does not narrow the current results, brings in products the current
   * results do not have, or only names the current query again is not shown (L01 — „halogen“ on a model search
   * changed nothing); two chips of one kind that lead to the same products are shown once (overlapping ranges).
   */
  function pageLang(lang) {
    var l = String(lang || '').toLowerCase().split('-')[0];
    if (!has(WORDS, l)) {
      try { l = typeof document !== 'undefined' && document.documentElement ? String(document.documentElement.lang || '').toLowerCase().split('-')[0] : ''; } catch (e) { l = ''; }
    }
    return has(WORDS, l) ? l : 'ka';
  }
  function sameText(a, b) { return fold(a).replace(/\s+/g, ' ').trim() === fold(b).replace(/\s+/g, ' ').trim(); }
  /* the searches chips lead to repeat while a customer types and refines: the last 300 are kept for the index */
  var REPLAY = { index: null, map: new Map() };
  function replay(index, text) {
    if (REPLAY.index !== index) { REPLAY.index = index; REPLAY.map = new Map(); }
    var map = REPLAY.map, hit = map.get(text);
    if (hit) { map.delete(text); map.set(text, hit); return hit; }
    hit = search(index, text, { _inner: true });
    map.set(text, hit);
    if (map.size > 300) map.delete(map.keys().next().value);
    return hit;
  }
  /**
   * opts.facets (optional) — what the caller will show: { order: [kinds], per: { kind: n }, each: n, max: n }. Only
   * that many chips are checked (the search window shows 8; /search shows every group, up to 12 values each).
   */
  function verifyFacets(index, result, groups, opts) {
    var plan = opts && opts.facets && typeof opts.facets === 'object' ? opts.facets : null;
    var lang = pageLang(opts && opts.lang), intent = result.intent, clarify = result.mode === 'clarify';
    var own = composeQuery(intent, lang), inMain = null, out = [];
    if (plan && Array.isArray(plan.order)) groups = plan.order.map(function (k) { return groups.filter(function (g) { return g.kind === k; })[0]; }).filter(Boolean);
    var left = plan && plan.max > 0 ? plan.max : Infinity;
    groups.forEach(function (g) {
      var limit = Math.min(left, plan ? (plan.per && plan.per[g.kind]) || plan.each || 12 : 12);
      var values = [], sigs = new Set();
      for (var vi = 0; vi < g.values.length && values.length < limit; vi++) {
        var v = g.values[vi];
        var q = composeQuery(intent, lang, function (x) { return withFacet(x, g.kind, v.key); });
        if (q.length < 2 || sameText(q, own) || sameText(q, intent.raw)) continue;
        var r = replay(index, q), n = r.total;
        if (!n || (r.mode !== 'intent' && r.mode !== 'sku')) continue;
        if (!clarify) {
          if (n >= result.total) continue;
          if (!inMain) { inMain = new Set(); result.main.forEach(function (it) { inMain.add(it.id); }); }
          var outside = false;
          for (var i = 0; i < r.main.length && !outside; i++) if (!inMain.has(r.main[i].id)) outside = true;
          if (outside) continue;
        }
        var sig = r.main.map(function (it) { return it.id; }).sort(function (a, b) { return a - b; }).join(',');
        if (sigs.has(sig)) continue;
        sigs.add(sig);
        values.push({ key: v.key, count: n, q: q, was: v.count });
      }
      left -= values.length;
      values.sort(function (x, y) { return y.count - x.count || y.was - x.was || String(x.key).localeCompare(String(y.key)); });
      if (values.length) out.push({ kind: g.kind, values: values.map(function (v) { return { key: v.key, count: v.count, q: v.q }; }) });
    });
    return out;
  }

  /* --------------------------------------------------- facets & relaxation */
  function genLabel(r) { return r.from === r.to ? String(r.from) : r.from + '–' + r.to; }
  function facetsOf(items, intent) {
    var groups = [];
    function group(kind, keyOf) {
      var counts = new Map();
      items.forEach(function (it) {
        var keys = keyOf(it) || [];
        uniq(keys).forEach(function (k) { if (k != null && k !== '') counts.set(k, (counts.get(k) || 0) + 1); });
      });
      if (counts.size < 2) return;
      var values = [];
      counts.forEach(function (count, key) { values.push({ key: key, count: count }); });
      values.sort(function (x, y) { return y.count - x.count || String(x.key).localeCompare(String(y.key)); });
      groups.push({ kind: kind, values: values.slice(0, 12) });
    }
    if (!intent.models.length) group('model', function (it) { return it.a.models; });
    if (!intent.years.length) group('gen', function (it) {
      var ms = intent.models.length ? it.a.models.filter(function (m) { return intent.models.indexOf(m) >= 0; }) : it.a.models;
      var out = [];
      ms.forEach(function (m) { (it.a.modelRanges[m] || []).forEach(function (r) { out.push(m + '|' + r.from + '|' + r.to); }); });
      return out;
    });
    if (intent.parts.length !== 1 || (intent.part === 'ფარი' && !intent.positionStated)) group('part', function (it) { return [it.a.part]; });
    if (!intent.positionStated) group('position', function (it) { return it.a.position === 'front' || it.a.position === 'rear' ? [it.a.position] : []; });
    if (!intent.side) group('side', function (it) { return it.a.side === 'L' || it.a.side === 'R' ? [it.a.side] : []; });
    if (!intent.quality) group('quality', function (it) { return it.a.quality ? [it.a.quality] : []; });
    if (!intent.led && !intent.excludeLed && items.some(function (it) { return it.a.part === 'ფარი' || it.a.part === 'უკანა ფარი'; })) group('led', function (it) { return (it.a.part === 'ფარი' || it.a.part === 'უკანა ფარი') ? [it.a.led ? 'led' : 'plain'] : []; });
    return groups;
  }

  /**
   * When nothing matches: which single condition, dropped, would give results (and how many). 1.2.0 (L02): each
   * suggestion carries the text it writes (`q`) and the count of that text's own search; one that writes the
   * current query again (a loop), an empty query or a query without products is not offered.
   */
  function relaxations(index, intent, opts) {
    var lang = pageLang(opts && opts.lang), own = composeQuery(intent, lang);
    function check(q) {
      if (q.length < 2 || sameText(q, own) || sameText(q, intent.raw)) return 0;
      var r = replay(index, q);
      return r.mode === 'intent' || r.mode === 'sku' ? r.total : 0;
    }
    var kinds = [];
    if (intent.years.length) kinds.push('year');
    if (intent.side) kinds.push('side');
    if (intent.positionStated) kinds.push('position');
    if (intent.level) kinds.push('level');
    if (intent.quality) kinds.push('quality');
    if (intent.led || intent.excludeLed) kinds.push('led');
    intent.terms.forEach(function (t, i) { kinds.push('term:' + i); });
    if (intent.features.length || intent.noFeatures.length) kinds.push('feature');
    if (intent.parts.length) kinds.push('part');
    if (intent.models.length) kinds.push('model');
    var out = [];
    kinds.forEach(function (kind) {
      var next = without(intent, kind);
      var q = composeQuery(next, lang);
      var count = check(q);
      if (count > 0) out.push({ kind: kind, intent: next, count: count, q: q });
    });
    // the generations the catalog does carry for the model (+ part) — the honest answer to a wrong year
    if (intent.years.length && intent.models.length) {
      var gens = new Map();
      var base = without(intent, 'year');
      index.items.forEach(function (it) {
        if (evaluate(base, it).status !== 'match') return;
        it.a.models.forEach(function (m) {
          if (intent.models.indexOf(m) < 0) return;
          (it.a.modelRanges[m] || []).forEach(function (r) { var k = m + '|' + r.from + '|' + r.to; gens.set(k, (gens.get(k) || 0) + 1); });
        });
      });
      var list = [], sigs = new Set(), byUse = [];
      gens.forEach(function (was, key) { byUse.push({ key: key, was: was }); });
      // of two ranges that lead to the same products the one more products are titled with is kept
      byUse.sort(function (x, y) { return y.was - x.was || String(x.key).localeCompare(String(y.key)); });
      byUse.forEach(function (g) {
        var key = g.key;
        var q = composeQuery(intent, lang, function (x) { return withFacet(x, 'gen', key); });
        var count = check(q);
        if (!count) return;
        var sig = replay(index, q).main.map(function (it) { return it.id; }).sort(function (a, b) { return a - b; }).join(',');
        if (sigs.has(sig)) return;
        sigs.add(sig);
        list.push({ key: key, count: count, q: q });
      });
      list.sort(function (x, y) { return Number(x.key.split('|')[1]) - Number(y.key.split('|')[1]) || Number(x.key.split('|')[2]) - Number(y.key.split('|')[2]); });
      out.gens = list.slice(0, 8);
    }
    return out;
  }
  function isLamp(part) { return part === 'ფარი' || part === 'უკანა ფარი'; }
  /** A free word that only qualifies the narrower kind („ძრავის“ in „ძრავის დამცავი“ = the engine guard itself). */
  function qualifies(intent, word) {
    var st = intent.subtype;
    return st !== null && st !== undefined && !!SUBTYPES[st] && SUBTYPES[st].item.test(word);
  }
  /**
   * A free word that is (a word of) the name of a part the intent already has — class C part names are matched as
   * words too, so „რადიატორი“ is both the part and a word, and „подушка двигателя“ two words of one part.
   */
  function namesPart(intent, word) {
    // R2 (F3): the parent is one of the query's own parts too („რადიატორის“ in „რადიატორის საფარი“)
    var own = intent.partOf ? intent.parts.concat([intent.partOf]) : intent.parts;
    var p = partTypeIn(word);
    if (p && p.cls === 'C' && own.indexOf(p.canon) >= 0) return true;
    if (!intent.text || !own.some(function (c) { var x = PART_BY.get(c); return x && x.cls === 'C'; })) return false;
    return wordsOfParts(intent).has(word);
  }
  function without(intent, kind) {
    var next = copyIntent(intent);
    if (kind === 'year') { next.years = []; next.range = null; }
    else if (kind === 'side') next.side = null;
    else if (kind === 'position') {
      next.positionStated = false;
      if (next.parts.indexOf('უკანა ფარი') >= 0) {
        // 1.2.0 (L02): „rear“ taken off a rear lamp leaves the lamps — the rear lamp kept it and the chip came back
        next.parts = uniq(next.parts.map(function (p) { return p === 'უკანა ფარი' ? 'ფარი' : p; }));
        if (next.part === 'უკანა ფარი') next.part = 'ფარი';
        next.position = null;
      } else {
        var ip = next.parts.length === 1 ? PART_BY.get(next.part) : null;
        next.position = ip && ip.position || null;
      }
    }
    else if (kind === 'level') next.level = null;
    else if (kind === 'quality') next.quality = null;
    else if (kind === 'led') { next.led = null; next.excludeLed = false; }
    else if (kind === 'part') {
      // the words that only named or qualified the part go with it; „plain“ is said of lamps only
      next.terms = next.terms.filter(function (t) { return !namesPart(intent, t.word) && !qualifies(intent, t.word); });
      next.parts = []; next.part = null; next.partOf = null; next.subtype = null; next.genitive = false; next.excludeLed = false;
      next.position = next.positionStated ? next.position : null;
    }
    else if (kind === 'model') { next.models = []; }
    else if (kind === 'brand') { next.brand = null; }
    else if (kind === 'feature') { next.features = []; next.noFeatures = []; }
    else if (kind.indexOf('term:') === 0) {
      var at = Number(kind.slice(5)), gone = intent.terms[at];
      next.terms = next.terms.filter(function (t, i) { return i !== at; });
      // „ძრავის“ off „ძრავის დამცავი“ is the engine-guard kind going away (the words would read it back otherwise)
      if (gone && qualifies(intent, gone.word)) next.subtype = null;
    }
    return next;
  }

  /* ------------------------------------------------ canonical query words */
  var WORDS = {
    ka: { L: 'მარცხენა', R: 'მარჯვენა', front: 'წინა', rear: 'უკანა', upper: 'ზედა', lower: 'ქვედა', orig: 'ორიგინალი', analog: 'ანალოგი', china: 'ჩინური', tong: 'Tong Yang', gordon: 'Gordon', led: 'LED', full: 'FULL LED', plain: 'ჩვეულებრივი' },
    ru: { L: 'левая', R: 'правая', front: 'передний', rear: 'задний', upper: 'верхний', lower: 'нижний', orig: 'оригинал', analog: 'аналог', china: 'китай', tong: 'Tong Yang', gordon: 'Gordon', led: 'LED', full: 'FULL LED', plain: 'обычная' },
    en: { L: 'left', R: 'right', front: 'front', rear: 'rear', upper: 'upper', lower: 'lower', orig: 'original', analog: 'aftermarket', china: 'china', tong: 'Tong Yang', gordon: 'Gordon', led: 'LED', full: 'FULL LED', plain: 'halogen' }
  };
  /** A part word the parser reads back as the same part (label in the language, else the Georgian canon). */
  function partWord(canon, lang) {
    var label = partLabel(canon, lang);
    var candidates = [label.split(/\s*[(/]/)[0], canon];
    for (var i = 0; i < candidates.length; i++) { var p = partTypeIn(candidates[i]); if (p && p.canon === canon) return candidates[i]; }
    return canon;
  }
  /*
   * 1.2.0 (L02): the words of the part are chosen so that the parser reads back exactly the same part, parent,
   * narrower kind and position — checked by parsing them, once per combination. Before, a label could add a
   * condition (EN „headlight“ = the FRONT lamp, RU „подкрылок“ / EN „liner“ = the fender-liner kind only), lose one
   * (the engine-guard kind) or not parse at all (KA „ფრთაის“).
   */
  var PART_ALT = {
    'ფარი': { en: ['lights', 'lamps'] }, 'დამცავი': { ru: ['защита'], en: ['splash guard', 'undercover'] },
    'დღის სინათლე': { ru: ['ходовые огни', 'дхо'] }, 'ნომრის ჩარჩო': { ru: ['номерная'], en: ['license plate'] },
    'საბუქსირე ხუფი': { ru: ['буксир'], en: ['tow hook'] }, 'ჟალუზი': { ru: ['жалюзи'] }, 'ცხაურა': { ru: ['решётка'] },
    'ლოკოკინა': { ru: ['клаксон'] }, 'ძელი': { en: ['reinforcement', 'crossmember'] }, 'გიტარა': { en: ['guitar'] },
    'საბარგული': { en: ['trunk', 'tailgate'] }
  };
  var SUBTYPE_WORDS = [
    { ka: ['ლოკერი', 'ფრთის დამცავი', 'ფრთის საფარი'], ru: ['подкрылок'], en: ['fender liner', 'liner'] },
    { ka: ['ძრავის დამცავი'], ru: ['защита двигателя'], en: ['engine guard'] }
  ];
  /** Georgian genitive of a part name („ფრთა“ → „ფრთის“, „ბამპერი“ → „ბამპერის“, „ჩარჩო“ → „ჩარჩოს“). */
  function genitiveKa(text) {
    var words = String(text).split(' '), last = words.pop();
    if (/[იაე]$/u.test(last)) last = last.slice(0, -1) + 'ის';
    else if (/[ოუ]$/u.test(last)) last += 'ს';
    else last += 'ის';
    words.push(last);
    return words.join(' ');
  }
  function wordsFor(canon, lang, subtype) {
    var p = PART_BY.get(canon), out = [];
    if (subtype !== null && SUBTYPE_WORDS[subtype]) out = out.concat(SUBTYPE_WORDS[subtype][lang] || [], SUBTYPE_WORDS[subtype].ka);
    var label = p ? (p.label[lang] || p.label.ka) : String(canon || '');
    label.split(/\s*[(/)]\s*/).forEach(function (x) { x = x.trim(); if (x) out.push(x); });
    if (PART_ALT[canon] && PART_ALT[canon][lang]) out = out.concat(PART_ALT[canon][lang]);
    out.push(canon);
    return uniq(out);
  }
  function defaultPosition(parts) {
    if (parts.length !== 1) return null;
    if (parts[0] === 'უკანა ფარი') return 'rear';
    var p = PART_BY.get(parts[0]);
    return p && p.position || null;
  }
  function phraseReads(text, want) {
    var p = parseQuery(text, null);
    if (p.models.length || p.brand || p.years.length || p.side || p.level || p.led || p.excludeLed || p.quality || p.features.length || p.noFeatures.length) return false;
    if (p.parts.length !== want.parts.length) return false;
    for (var i = 0; i < want.parts.length; i++) if (p.parts.indexOf(want.parts[i]) < 0) return false;
    if (want.partOf !== undefined && (p.partOf || null) !== want.partOf) return false; // undefined: any parent
    if ((p.subtype === null || p.subtype === undefined ? null : p.subtype) !== want.subtype) return false;
    if ((p.position || null) !== want.position) return false;
    for (var j = 0; j < p.terms.length; j++) if (!namesPart(p, p.terms[j].word) && !qualifies(p, p.terms[j].word)) return false;
    return true;
  }
  var PHRASE_MEMO = new Map();
  /*
   * The words of the part(s) + what they carry by themselves when read back: the narrower kind (`sub`) and a stated
   * position (`pos`). composeQuery leaves out a qualifying word / the separate position word only when the phrase
   * already carries it (1.2.0 R2 — „ძრავის“ went missing from „ძრავის დამცავი და ბამპერი“, „უკანა უკანა ფარი“).
   */
  function phraseInfo(next, lang) {
    var parts = next.parts.slice();
    if (!parts.length) return { text: '', sub: null, pos: null };
    // a stated „rear“ is written as its own word; the lamp itself then reads back as the rear lamp
    if (next.positionStated && parts.length === 1 && parts[0] === 'უკანა ფარი') parts = ['ფარი'];
    var single = parts.length === 1;
    // R2 (F1): the narrower kind belongs to the phrase with several parts too („Kona liner + air duct“)
    var sub = next.subtype !== null && next.subtype !== undefined && SUBTYPES[next.subtype] ? next.subtype : null;
    var parent = single && next.partOf ? next.partOf : null;
    var stated = next.positionStated && next.position ? next.position : null;
    var key = lang + '|' + parts.join('+') + '|' + parent + '|' + sub + '|' + stated;
    if (PHRASE_MEMO.has(key)) return PHRASE_MEMO.get(key);
    var dflt = defaultPosition(parts);
    // the part's own position first; a phrase that says the stated position itself is the second choice („кронштейн
    // задний фонарь“ — the rear lamp's bracket cannot be named without „rear“ in RU / EN)
    var positions = stated && stated !== dflt ? [dflt, stated] : [dflt];
    var budget = 200; // phrases parsed for one combination, all languages together (each result is kept in PHRASE_MEMO)
    function attempt(L, position) {
      var want = { parts: parts, partOf: parent, subtype: sub, position: position }, tries = 0, seen = new Set();
      // in another language the words stay in that language (the Georgian name is not mixed into them)
      var words = function (c, st) { var w = wordsFor(c, L, st); return L === lang || L === 'ka' ? w : w.filter(function (x) { return !/[\u10A0-\u10FF]/.test(x); }); };
      var reads = function (t, w) { if (seen.has(t) || budget <= 0) return false; seen.add(t); budget--; return phraseReads(t, w); };
      if (single) {
        var heads = words(parts[0], sub), parents = parent ? words(parent, null) : [null];
        for (var i = 0; i < parents.length; i++) {
          for (var j = 0; j < heads.length; j++) {
            var cands = parents[i] === null ? [heads[j]]
              : L === 'ka' ? [genitiveKa(parents[i]) + ' ' + heads[j]]
              : L === 'ru' ? [heads[j] + ' ' + parents[i], parents[i] + ' ' + heads[j]]
              : [parents[i] + ' ' + heads[j], heads[j] + ' ' + parents[i]];
            // a word said twice („fender fender liner“) is left out: the head may carry the parent by itself
            if (parents[i] !== null) cands = cands.filter(function (t) { return !/(^|\s)(\S+)\s(?:.*\s)?\2(\s|$)/i.test(t); }).concat([heads[j]]);
            for (var k = 0; k < cands.length; k++) {
              if (seen.has(cands[k])) continue;
              if (++tries > 80 || budget <= 0) return null;
              if (reads(cands[k], want)) return cands[k];
            }
          }
        }
        return null;
      }
      // several parts: each in a word that reads back alone, joined so that the parser splits them again; the words
      // of the narrower kind go to the one part they read back with
      var subUsed = sub === null;
      var pieces = parts.map(function (p) {
        var pos1 = defaultPosition([p]);
        if (!subUsed) {
          // the kind's words may name their own parent („ფრთის საფარი“) — the joined phrase is checked below
          var ws1 = words(p, sub), one1 = { parts: [p], partOf: undefined, subtype: sub, position: pos1 };
          for (var y = 0; y < ws1.length; y++) if (phraseReads(ws1[y], one1)) { subUsed = true; return ws1[y]; }
        }
        var ws = words(p, null), one = { parts: [p], partOf: null, subtype: null, position: pos1 };
        for (var x = 0; x < ws.length; x++) if (phraseReads(ws[x], one)) return ws[x];
        return partWord(p, L);
      });
      if (budget-- <= 0) return null;
      return phraseReads(pieces.join(' + '), want) ? pieces.join(' + ') : null;
    }
    var found = null;
    for (var pi = 0; pi < positions.length && !found; pi++) found = attempt(lang, positions[pi]);
    if (!found) {
      // nothing reads back exactly in the page's language: the closest words (as before 1.2.0) when they still name
      // the same part, parent, narrower kind and position (a leftover word is dropped by the search) …
      var old = [];
      if (parent) old.push(lang === 'ka' ? genitiveKa(partWord(parent, lang)) : partWord(parent, lang));
      parts.forEach(function (p) { old.push(partWord(p, lang)); });
      old = old.join(single ? ' ' : ' + ');
      var o = parseQuery(old, null), close = (o.partOf || null) === parent && (o.subtype === null || o.subtype === undefined ? null : o.subtype) === sub &&
        positions.indexOf(o.position || null) >= 0 && o.parts.length === parts.length && parts.every(function (p) { return o.parts.indexOf(p) >= 0; });
      // … else (R2, F2: KA „ფრთის საფარი“ reads as the fender-liner kind) the other two languages — the parser reads
      // all three, English is the plainest
      if (!close) {
        var langs = ['en', 'ka', 'ru'].filter(function (x) { return x !== lang; });
        for (var li = 0; li < langs.length && !found; li++) for (var pj = 0; pj < positions.length && !found; pj++) found = attempt(langs[li], positions[pj]);
      }
      if (!found) found = old;
    }
    var read = parseQuery(found, null);
    var info = { text: found, sub: read.subtype === null || read.subtype === undefined ? null : read.subtype, pos: read.positionStated ? read.position : null };
    PHRASE_MEMO.set(key, info);
    return info;
  }
  /** Readable query text for an intent (facet chips and „remove this condition“ links write it into ?q=). */
  function composeQuery(intent, lang, change) {
    lang = pageLang(lang);
    var w = WORDS[lang];
    var next = change ? change(copyIntent(intent)) || intent : intent;
    var parts = [];
    next.models.forEach(function (m) { parts.push(modelName(m)); });
    if (!next.models.length && next.brand) parts.push(next.brand);
    if (next.range && next.years.length > 1) parts.push(next.range.from + '-' + next.range.to);
    else next.years.forEach(function (y) { parts.push(String(y)); });
    var info = phraseInfo(next, lang), phrase = info.text;
    // the separate position word only when the part's words do not say it already
    if (next.positionStated && next.position && !(phrase && info.pos === next.position)) parts.push(w[next.position]);
    if (next.level) parts.push(w[next.level]);
    if (phrase) parts.push(phrase);
    if (next.side === 'L' || next.side === 'R') parts.push(w[next.side]);
    if (next.led === 'full') parts.push(w.full); else if (next.led === 'led') parts.push(w.led); else if (next.excludeLed) parts.push(w.plain);
    if (next.quality) parts.push(w[next.quality]);
    (next.features || []).forEach(function (k) { var f = FEATURES.filter(function (x) { return x.key === k; })[0]; if (f) parts.push(f.words[lang] || f.words.ka); });
    (next.noFeatures || []).forEach(function (k) { var f = FEATURES.filter(function (x) { return x.key === k; })[0]; if (f) parts.push(lang === 'ru' ? 'без ' + f.words.en : lang === 'en' ? 'without ' + f.words.en : f.words.en + ' გარეშე'); });
    // a word that only names / qualifies the part is already in the part's own words
    next.terms.forEach(function (t) { if (!(phrase && (namesPart(next, t.word) || (qualifies(next, t.word) && info.sub === next.subtype)))) parts.push(t.word); });
    if (!parts.length && next.skuCands && next.skuCands.length) parts.push(next.skuCands[0]);
    return parts.join(' ').replace(/\s+/g, ' ').trim();
  }
  function copyIntent(intent) {
    var next = {};
    Object.keys(intent).forEach(function (k) { next[k] = Array.isArray(intent[k]) ? intent[k].slice() : intent[k]; });
    return next;
  }
  /** Apply a facet value to an intent (returns the new intent). */
  function withFacet(intent, kind, key) {
    var next = copyIntent(intent);
    if (kind === 'model') next.models = [key];
    else if (kind === 'gen') { var g = String(key).split('|'); next.models = [g[0]]; next.years = []; for (var y = Number(g[1]); y <= Number(g[2]); y++) next.years.push(y); next.range = { from: Number(g[1]), to: Number(g[2]) }; }
    else if (kind === 'part') {
      // 1.2.0: the new part reads as the parser reads it — its own position, no older narrower kind or naming word
      next.terms = next.terms.filter(function (t) { return !namesPart(intent, t.word) && !qualifies(intent, t.word); });
      next.parts = [key]; next.part = key; next.partOf = null; next.subtype = null;
      if (key === 'უკანა ფარი') { next.positionStated = false; next.position = 'rear'; }
      else if (key === 'ფარი' && next.positionStated && next.position === 'rear') { next.parts = ['უკანა ფარი']; next.part = 'უკანა ფარი'; }
      else if (!next.positionStated) next.position = defaultPosition([key]);
    }
    else if (kind === 'position') {
      next.position = key; next.positionStated = true;
      if (key === 'front' && next.parts.indexOf('უკანა ფარი') >= 0) { next.parts = uniq(next.parts.map(function (p) { return p === 'უკანა ფარი' ? 'ფარი' : p; })); if (next.part === 'უკანა ფარი') next.part = 'ფარი'; }
      else if (key === 'rear' && next.parts.indexOf('ფარი') >= 0) { next.parts = uniq(next.parts.map(function (p) { return p === 'ფარი' ? 'უკანა ფარი' : p; })); if (next.part === 'ფარი') next.part = 'უკანა ფარი'; }
    }
    else if (kind === 'side') next.side = key;
    else if (kind === 'quality') next.quality = key;
    else if (kind === 'led') {
      if (key === 'led') { next.led = 'led'; next.excludeLed = false; } else { next.led = null; next.excludeLed = true; }
      // 1.2.0 (L01): the lamp technology is said of lamps — on a search without a lamp the chip brings the lamps
      // with it (it counted lamps only; „Tucson halogen“ alone reads back as „Tucson“)
      if (!next.parts.some(isLamp)) {
        var rear = next.positionStated && next.position === 'rear';
        next.parts = [rear ? 'უკანა ფარი' : 'ფარი']; next.part = next.parts[0]; next.partOf = null; next.subtype = null;
        if (!next.positionStated) next.position = rear ? 'rear' : null;
        next.terms = next.terms.filter(function (t) { return !namesPart(intent, t.word) && !qualifies(intent, t.word); });
      }
    }
    return next;
  }
  /** The conditions the engine read from a query, for „we understood: …“ chips (each removable). */
  function describeIntent(intent, lang) {
    var w = WORDS[lang] || WORDS.ka, out = [];
    if (intent.models.length) out.push({ kind: 'model', label: intent.models.map(modelName).join(' / ') });
    else if (intent.brand) out.push({ kind: 'brand', label: intent.brand });
    if (intent.years.length) out.push({ kind: 'year', label: intent.range && intent.years.length > 1 ? intent.range.from + '–' + intent.range.to : intent.years.join(', ') });
    if (intent.parts.length) out.push({ kind: 'part', label: intent.parts.map(function (p) { return partLabel(p, lang); }).join(' + ') + (intent.partOf ? ' (' + partLabel(intent.partOf, lang) + ')' : '') });
    // 1.2.0: a stated position the part has anyway („წინა კაპოტი“, EN „front panel“) is no condition of its own —
    // removing it changed nothing and the words brought it back; „rear“ of the rear lamp stays (it leaves the lamps)
    var own = intent.parts.length === 1 && intent.parts[0] !== 'უკანა ფარი' && defaultPosition(intent.parts) === intent.position;
    if (intent.positionStated && intent.position && !own) out.push({ kind: 'position', label: w[intent.position] });
    if (intent.level) out.push({ kind: 'level', label: w[intent.level] });
    if (intent.side === 'L' || intent.side === 'R') out.push({ kind: 'side', label: w[intent.side] });
    if (intent.led) out.push({ kind: 'led', label: intent.led === 'full' ? w.full : w.led });
    else if (intent.excludeLed) out.push({ kind: 'led', label: w.plain });
    if (intent.quality) out.push({ kind: 'quality', label: w[intent.quality] });
    if ((intent.features || []).length || (intent.noFeatures || []).length) {
      var fl = [];
      intent.features.forEach(function (k) { var f = FEATURES.filter(function (x) { return x.key === k; })[0]; if (f) fl.push(f.words[lang] || f.words.ka); });
      intent.noFeatures.forEach(function (k) { var f = FEATURES.filter(function (x) { return x.key === k; })[0]; if (f) fl.push('− ' + (f.words[lang] || f.words.ka)); });
      out.push({ kind: 'feature', label: fl.join(', ') });
    }
    // 1.2.0: a word that is the name of the part already shown is not a second chip (removing either read it back)
    intent.terms.forEach(function (t, i) { if (!namesPart(intent, t.word)) out.push({ kind: 'term:' + i, label: t.word }); });
    return out;
  }

  /* -------------------------------------------------------- UI messages */
  var MESSAGES = {
    ka: {
      clarify: 'მოთხოვნაში მოდელი ან ნაწილი არ ჩანს — დააზუსტე:', clarifyShort: 'დააზუსტე მოდელი ან ნაწილი.', toConfirm: 'დასაზუსტებელი', soldOut: 'გზაშია', term_ignored: '„{word}“ ამ ნაწილებში ვერ მოიძებნა — ნაჩვენებია მის გარეშე.', matching: '{n} პროდუქტი შეესაბამება.', feature: 'აღჭურვილობა', brand: 'მარკა', year: 'წელი', level: 'დონე',
      results: '{n} შედეგი', of: '{shown} / {total}', understood: 'ვეძებთ:', remove: 'მოხსნა: {x}',
      refine: 'დააზუსტე:', model: 'მოდელი', gen: 'თაობა', part: 'ნაწილი', position: 'მდებარეობა', side: 'მხარე', quality: 'ხარისხი', led: 'ნათურა',
      plainLed: 'ჩვეულებრივი', plainLamp: 'ჩვეულებრივი ფარი', ledLamp: 'LED ფარი', unknownTitle: 'შესაძლოა მოერგოს — თავსებადობა დასაზუსტებელია ({n})', unknownHint: 'ამ ნაწილების მონაცემში {what} მითითებული არ არის. ყიდვამდე გადაამოწმე ან მოგვწერე.',
      unknown_model: 'მოდელი', unknown_year: 'წელი', unknown_side: 'მხარე', unknown_part: 'ნაწილის ტიპი', unknown_brand: 'მარკა',
      relatedTitle: 'დაკავშირებული დეტალები ({n})', qualityTitle: 'სხვა ხარისხის ვარიანტები ({n})',
      sku_exact: 'ნაპოვნია ზუსტი კოდით.', sku_prefix: 'ნაპოვნია კოდის დასაწყისით.',
      term_dropped: 'სიტყვა „{word}“ კატალოგში ვერ მოიძებნა და ძებნაში არ ჩავთვალეთ.', term_corrected: '„{from}“ → „{to}“ (შესწორებულია)',
      model_corrected: '„{from}“ წავიკითხეთ როგორც {to}.', model_not_carried: '{model}-ის ნაწილები ჩვენს კატალოგში არ არის.',
      foreign_make: 'Partpoint-ში მხოლოდ HYUNDAI & KIA-ს ნაწილებია.', year_out_of_catalog: 'კატალოგში {from}–{to} წლის მოდელების ნაწილებია; {year} წელი ამ დიაპაზონს გარეთაა.',
      quality_none: 'ამ მოთხოვნით {quality} ვარიანტი ვერ მოიძებნა — ქვემოთ სხვა ხარისხია.', vin: 'VIN კოდით ძებნისთვის გამოიყენე VIN-ის ველი (მოდელის არჩევა). აქ VIN არ ინახება.',
      none: 'ზუსტი დამთხვევა ვერ მოიძებნა.', tryInstead: 'სცადე:', gensTitle: 'კატალოგში არსებული თაობები:',
      loading: 'ძიება…', added: 'დაემატა {n} შედეგი. ნაჩვენებია {shown} / {total}.', allShown: 'ნაჩვენებია ყველა {total} შედეგი.',
      loadMore: 'მეტის ნახვა', sort: 'დახარისხება', relevance: 'შესაბამისობით', viewAll: 'ყველა შედეგის ნახვა ({n})',
      suggestNone: 'ზუსტი დამთხვევა ვერ მოიძებნა. Enter — სრული ძებნა.', unavailable: 'ძებნის ინდექსი ვერ ჩაიტვირთა — ნაჩვენებია Shopify-ის ძებნის შედეგები.',
      orig: 'ორიგინალი', analog: 'ანალოგი', china: 'ანალოგი (China)', tong: 'Tong Yang', gordon: 'Gordon', front: 'წინა', rear: 'უკანა', L: 'მარცხენა', R: 'მარჯვენა', upper: 'ზედა', lower: 'ქვედა'
    },
    ru: {
      clarify: 'В запросе не видно модели или детали — уточните:', clarifyShort: 'Уточните модель или деталь.', toConfirm: 'уточнить', soldOut: 'Продано', term_ignored: '«{word}» у этих деталей не найдено — показано без него.', matching: 'Подходит товаров: {n}.', feature: 'Оснащение', brand: 'Марка', year: 'Год', level: 'Уровень',
      results: 'Результаты: {n}', of: '{shown} из {total}', understood: 'Ищем:', remove: 'Убрать: {x}',
      refine: 'Уточните:', model: 'Модель', gen: 'Поколение', part: 'Деталь', position: 'Расположение', side: 'Сторона', quality: 'Качество', led: 'Лампа',
      plainLed: 'Обычная', plainLamp: 'Обычные фары', ledLamp: 'LED фары', unknownTitle: 'Может подойти — совместимость нужно уточнить ({n})', unknownHint: 'В данных этих деталей не указано: {what}. Проверьте перед покупкой или напишите нам.',
      unknown_model: 'модель', unknown_year: 'год', unknown_side: 'сторона', unknown_part: 'тип детали', unknown_brand: 'марка',
      relatedTitle: 'Связанные детали ({n})', qualityTitle: 'Варианты другого качества ({n})',
      sku_exact: 'Найдено по точному коду.', sku_prefix: 'Найдено по началу кода.',
      term_dropped: 'Слово «{word}» в каталоге не найдено и не учтено.', term_corrected: '«{from}» → «{to}» (исправлено)',
      model_corrected: '«{from}» прочитано как {to}.', model_not_carried: 'Запчастей для {model} в нашем каталоге нет.',
      foreign_make: 'В Partpoint только запчасти HYUNDAI и KIA.', year_out_of_catalog: 'В каталоге запчасти для моделей {from}–{to} годов; {year} год вне этого диапазона.',
      quality_none: 'Вариант «{quality}» по этому запросу не найден — ниже другое качество.', vin: 'Для поиска по VIN используйте поле VIN (выбор модели). Здесь VIN не сохраняется.',
      none: 'Точных совпадений не найдено.', tryInstead: 'Попробуйте:', gensTitle: 'Поколения в каталоге:',
      loading: 'Поиск…', added: 'Добавлено результатов: {n}. Показано {shown} из {total}.', allShown: 'Показаны все результаты: {total}.',
      loadMore: 'Показать ещё', sort: 'Сортировка', relevance: 'По соответствию', viewAll: 'Все результаты ({n})',
      suggestNone: 'Точных совпадений нет. Enter — полный поиск.', unavailable: 'Индекс поиска не загрузился — показаны результаты поиска Shopify.',
      orig: 'Оригинал', analog: 'Аналог', china: 'Аналог (China)', tong: 'Tong Yang', gordon: 'Gordon', front: 'Передний', rear: 'Задний', L: 'Левая', R: 'Правая', upper: 'Верхний', lower: 'Нижний'
    },
    en: {
      clarify: 'No model or part in the query — refine:', clarifyShort: 'Add a model or a part.', toConfirm: 'to be confirmed', soldOut: 'On the way', term_ignored: '“{word}” is not on these parts — shown without it.', matching: '{n} products match.', feature: 'Equipment', brand: 'Make', year: 'Year', level: 'Level',
      results: '{n} results', of: '{shown} of {total}', understood: 'Searching for:', remove: 'Remove: {x}',
      refine: 'Refine:', model: 'Model', gen: 'Generation', part: 'Part', position: 'Position', side: 'Side', quality: 'Quality', led: 'Lamp',
      plainLed: 'Halogen', plainLamp: 'Halogen lights', ledLamp: 'LED lights', unknownTitle: 'May fit — compatibility to be confirmed ({n})', unknownHint: 'These parts do not state the {what}. Check before buying or message us.',
      unknown_model: 'model', unknown_year: 'year', unknown_side: 'side', unknown_part: 'part type', unknown_brand: 'make',
      relatedTitle: 'Related parts ({n})', qualityTitle: 'Other quality options ({n})',
      sku_exact: 'Found by exact part code.', sku_prefix: 'Found by the beginning of the part code.',
      term_dropped: 'The word “{word}” is not in the catalog and was ignored.', term_corrected: '“{from}” → “{to}” (corrected)',
      model_corrected: '“{from}” was read as {to}.', model_not_carried: 'Parts for the {model} are not in our catalog.',
      foreign_make: 'Partpoint carries HYUNDAI & KIA parts only.', year_out_of_catalog: 'The catalog covers {from}–{to} models; {year} is outside that range.',
      quality_none: 'No “{quality}” option for this request — other quality below.', vin: 'To search by VIN use the VIN field (vehicle selector). The VIN is not stored here.',
      none: 'No exact match found.', tryInstead: 'Try:', gensTitle: 'Generations in the catalog:',
      loading: 'Searching…', added: '{n} results added. Showing {shown} of {total}.', allShown: 'All {total} results shown.',
      loadMore: 'Load more', sort: 'Sort by', relevance: 'Relevance', viewAll: 'View all results ({n})',
      suggestNone: 'No exact match. Press Enter for full search.', unavailable: 'The search index did not load — showing Shopify search results.',
      orig: 'Genuine', analog: 'Aftermarket', china: 'Aftermarket (China)', tong: 'Tong Yang', gordon: 'Gordon', front: 'Front', rear: 'Rear', L: 'Left', R: 'Right', upper: 'Upper', lower: 'Lower'
    }
  };
  function msg(lang, key, params) {
    var dict = MESSAGES[lang] || MESSAGES.ka;
    var s = has(dict, key) ? dict[key] : (MESSAGES.ka[key] || key);
    return s.replace(/\{(\w+)\}/g, function (m, k) { return params && params[k] != null ? String(params[k]) : m; });
  }
  /** 1.2.0: with the intent, the LED/plain chip of a search without a lamp says that it brings the lamps (L01). */
  function facetLabel(kind, key, lang, intent) {
    if (kind === 'led' && intent && intent.parts && !intent.parts.some(isLamp)) return msg(lang, key === 'led' ? 'ledLamp' : 'plainLamp');
    if (kind === 'model') return modelName(key);
    if (kind === 'gen') { var g = String(key).split('|'); return modelName(g[0]) + ' ' + genLabel({ from: Number(g[1]), to: Number(g[2]) }); }
    if (kind === 'part') return partLabel(key, lang);
    if (kind === 'led') return key === 'led' ? 'LED' : msg(lang, 'plainLed');
    return msg(lang, key);
  }

  /* -------------------------------------------------- browser index loader */
  var LOADER = null;
  function makeLoader(root) {
    var memo = null;
    var TTL = 5 * 60 * 1000, KEY = 'pp-sx-v2';
    function store() { try { return root.localStorage; } catch (e) { return null; } }
    /**
     * The cached index: { fresh } within the 5-minute TTL (used as is, no network); once the TTL has passed it is
     * only { prior } — never shown: the rows (prices, availability, titles) are always fetched again, and the
     * prior entry only lends the computed attributes of products whose attribute inputs did not change (1.1.0).
     */
    function readCache(locale) {
      var ls = store(); if (!ls) return null;
      try {
        var v = JSON.parse(ls.getItem(KEY + ':' + locale) || 'null');
        if (!v || v.v !== 1 || !Array.isArray(v.rows) || v.rows.length !== v.count) return null;
        if (Date.now() - v.ts <= TTL && Date.now() >= v.ts) return { fresh: v };
        return v.core === VERSION && Array.isArray(v.attrs) && v.attrs.length === v.rows.length ? { prior: v } : null;
      } catch (e) { return null; }
    }
    function writeCache(locale, payload) {
      var ls = store(); if (!ls) return;
      try { ls.setItem(KEY + ':' + locale, JSON.stringify(payload)); } catch (e) { try { ls.removeItem(KEY + ':' + locale); } catch (e2) { /* quota */ } }
    }
    // 1.1.0: serializing the whole index (~0.5–0.8 MB) used to run before the index reached the page — inside the
    // task that renders the first results. It now runs when the page is idle, and at the latest when the page is
    // left (pagehide / hidden), so a quick click on a suggestion still keeps the cache for the next page.
    var pending = null, flushBound = false;
    function flushCache() { var p = pending; pending = null; if (p) writeCache(p.locale, p.payload); }
    function writeCacheLater(locale, payload) {
      pending = { locale: locale, payload: payload };
      if (!flushBound && typeof root.addEventListener === 'function') {
        flushBound = true;
        root.addEventListener('pagehide', flushCache);
        var doc = root.document;
        if (doc && typeof doc.addEventListener === 'function') doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden') flushCache(); });
      }
      if (typeof root.requestIdleCallback === 'function') root.requestIdleCallback(flushCache, { timeout: 2000 });
      else setTimeout(flushCache, 250);
    }
    /** Attributes of the prior cache entry for rows whose attribute inputs (Georgian title, tags, type, vendor) are unchanged. */
    function carryAttrs(rows, prior) {
      var byId = new Map();
      prior.rows.forEach(function (r, i) { if (r && prior.attrs[i] && prior.attrs[i].v === VERSION) byId.set(r.id, i); });
      var out = new Array(rows.length), reused = 0;
      rows.forEach(function (r, j) {
        var i = byId.get(r.id);
        if (i === undefined || attrKey(prior.rows[i]) !== attrKey(r)) return;
        out[j] = prior.attrs[i]; reused++;
      });
      return reused ? out : null;
    }
    function attrKey(r) {
      var tags = Array.isArray(r.tags) ? r.tags.map(String) : [];
      return JSON.stringify([String(r.titleKa || r.title || ''), tags, String(r.type || ''), String(r.vendor || '')]);
    }
    function fetchText(url, ms) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms);
      return fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
        .finally(function () { clearTimeout(timer); });
    }
    var BLOCK = /<script type="application\/json" data-pp-search-index>([\s\S]*?)<\/script>/;
    function page(base, n, mode) {
      var url = new URL(base + 'collections/all', root.location.origin);
      url.searchParams.set('section_id', 'pp-search-index');
      url.searchParams.set('sort_by', 'created-ascending');
      url.searchParams.set('page', String(n));
      var preview = new URL(root.location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d{1,20}$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      var attempt = function (tries) {
        return fetchText(url.href, 8000).then(function (html) {
          var m = BLOCK.exec(html);
          if (!m) throw new Error('no index block');
          var data = JSON.parse(m[1]);
          if (!data || data.v !== 1 || data.mode !== mode || !Array.isArray(data.items) || typeof data.count !== 'number') throw new Error('bad index page');
          return data;
        }).catch(function (err) {
          if (tries > 0) return new Promise(function (r) { setTimeout(r, 400); }).then(function () { return attempt(tries - 1); });
          throw err;
        });
      };
      return attempt(1);
    }
    /**
     * Every page of one listing; rejects unless the unique ids equal the collection count (a partial index never answers).
     * 1.1.0: `guess` (pages expected from a hint: the previous index or the /search page's product count) lets pages
     * 2…guess start together with page 1 instead of after it — one Shopify section render + round trip less. Page 1
     * still decides: missing pages are fetched after it, surplus ones are ignored, and every check below is unchanged.
     */
    function listing(base, mode, guess) {
      var early = {}, g = Math.min(Math.floor(Number(guess) || 0), 40);
      for (var k = 2; k <= g; k++) { early[k] = page(base, k, mode); early[k].catch(function () { /* judged after page 1 */ }); }
      return page(base, 1, mode).then(function (first) {
        var pages = Math.min(Number(first.pages) || 1, 40), jobs = [];
        for (var n = 2; n <= pages; n++) jobs.push(early[n] || page(base, n, mode));
        return Promise.all(jobs).then(function (rest) {
          var all = [first].concat(rest), rows = [], ids = new Set();
          for (var i = 0; i < all.length; i++) {
            if (all[i].count !== first.count) throw new Error('catalog changed while reading');
            for (var j = 0; j < all[i].items.length; j++) {
              var row = all[i].items[j];
              if (!Array.isArray(row) || ids.has(row[0])) continue;
              ids.add(row[0]);
              row.order = i * 250 + j;
              rows.push(row);
            }
          }
          if (rows.length !== first.count || !rows.length) throw new Error('incomplete index ' + rows.length + '/' + first.count);
          return { count: first.count, money: first.money, rows: rows };
        });
      });
    }
    function toRows(full, titles) {
      var local = titles ? new Map(titles.rows.map(function (r) { return [r[0], r[1]]; })) : null;
      return full.rows.map(function (r) {
        return { id: r[0], handle: r[1], titleKa: r[2], title: (local && local.get(r[0])) || r[2], sku: r[3], vendor: r[4], type: r[5], tags: r[6], price: r[7], compare: r[8], available: r[9] === 1, img: r[10], imgW: r[11], order: r.order };
      });
    }
    function load(opts) {
      opts = opts || {};
      var shop = root.Shopify || {};
      var localeElement = root.document && root.document.documentElement;
      var localeRoot = (localeElement && localeElement.getAttribute && localeElement.getAttribute('data-pp-locale-root')) || (shop.routes && shop.routes.root) || '/';
      if (localeRoot.slice(-1) !== '/') localeRoot += '/';
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(localeRoot)) localeRoot = '/';
      var locale = (root.document && root.document.documentElement.lang || 'ka').split('-')[0].toLowerCase();
      if (memo && memo.locale === locale && !opts.fresh && Date.now() - memo.at < TTL) return memo.promise;
      warmRegexes(); // background priority: fills the network wait, never delays the index or the query
      var entry = opts.fresh ? null : readCache(locale);
      var cached = entry && entry.fresh && entry.fresh.localeRoot === localeRoot ? entry.fresh : null;
      var prior = entry && entry.prior ? entry.prior : null;
      var promise;
      if (cached) {
        promise = finish(cached, true, null);
      } else {
        var hint = prior ? prior.count : Number(localeElement && localeElement.getAttribute && localeElement.getAttribute('data-pp-index-count')) || 0;
        var guess = hint > 0 ? Math.ceil(hint / 250) : 0;
        var jobs = [listing('/', 'full', guess)];
        if (localeRoot !== '/') jobs.push(listing(localeRoot, 'titles', guess).catch(function () { return null; }));
        promise = Promise.all(jobs).then(function (res) {
          return finish({ v: 1, ts: Date.now(), count: res[0].count, money: res[0].money, localeRoot: localeRoot, rows: toRows(res[0], res[1] || null) }, false, prior);
        });
      }
      function finish(payload, fromCache, prior) {
        var reuse = payload.core === VERSION && Array.isArray(payload.attrs) && payload.attrs.length === payload.rows.length;
        var attrs = reuse ? payload.attrs : prior ? carryAttrs(payload.rows, prior) : null;
        return buildIndexAsync(payload.rows, attrs).then(function (index) {
          if (index.items.length !== payload.count) throw new Error('index size mismatch');
          if (!reuse || !fromCache) {
            payload.core = VERSION;
            payload.attrs = index.items.map(function (it) { return it.a; });
            writeCacheLater(locale, payload);
          }
          index.count = payload.count; index.money = payload.money || '{{amount}} GEL'; index.localeRoot = payload.localeRoot || localeRoot; index.fromCache = fromCache;
          return index;
        });
      }
      memo = { locale: locale, at: Date.now(), promise: promise };
      promise.catch(function () { if (memo && memo.promise === promise) memo = null; });
      return promise;
    }
    return { load: load, peek: function () { return memo; } };
  }
  function loadIndex(opts) {
    if (typeof window === 'undefined' || typeof fetch !== 'function') return Promise.reject(new Error('no browser'));
    if (!LOADER) LOADER = makeLoader(window);
    return LOADER.load(opts);
  }

  /* ------------------------------------------------------------ helpers */
  function formatMoney(cents, format) {
    var fmt = typeof format === 'string' && format ? format : '{{amount}} GEL';
    var value = (Number(cents) || 0) / 100;
    function group(num, dec, thousands, decimal) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, kind) {
      switch (kind) {
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_with_period_and_space_separator': return group(value, 2, ' ', '.');
        default: return group(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  /** Same-origin product URL; the handle is URL-encoded, never trusted as a path. */
  function productUrl(item, localeRoot) {
    var base = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(localeRoot || '') ? localeRoot : '/';
    return base + 'products/' + encodeURIComponent(item.handle);
  }
  /** Shopify CDN image URL at a width, from the stored `files/…?v=…` path (same origin only). */
  function imageUrl(item, width) {
    if (!item.img || !/^(?:files|products|collections|articles)\/[\w\-./%]+(?:\?[\w=&%.\-]*)?$/.test(item.img) || item.img.indexOf('..') >= 0 || item.img.indexOf('//') >= 0) return '';
    var url = '/cdn/shop/' + item.img;
    return width ? url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width : url;
  }

  WARM_OPEN = false; // patterns made later (per query term) are not part of the start-up set
  return {
    version: VERSION, supported: true,
    fold: fold, clean: clean, normSku: normSku,
    parseQuery: parseQuery, buildIndex: buildIndex, buildIndexAsync: buildIndexAsync, warmRegexes: warmRegexes, search: search, evaluate: evaluate,
    composeQuery: composeQuery, withFacet: withFacet, without: without, describeIntent: describeIntent,
    facetLabel: facetLabel, msg: msg, partLabel: partLabel, modelName: modelName, genLabel: genLabel,
    formatMoney: formatMoney, productUrl: productUrl, imageUrl: imageUrl, loadIndex: loadIndex,
    _internals: { partTypeIn: partTypeIn, partParentIn: partParentIn, directModels: directModels, fuzzyModel: fuzzyModel, rangesIn: rangesIn, queryYears: queryYears, axesIn: axesIn, queryQuality: queryQuality, contentTerms: contentTerms, PARTS: PARTS, MODELS: MODELS, SORTS: SORTS }
  };
}));